/*jshint unused:false*/
/*global fetch */
/*global console */

// Csrf Token
let form_token;
const keepTokenAlive = async function () {
  try {
    const resp = await fetch('/account/token', {
      method: 'GET',
    });
    if (resp.ok) {
      const data = await resp.json();
      if (data.token) {
        document.querySelectorAll('[name="_token"]').forEach(v => {
          v.setAttribute('value', data.token);
        });
        form_token = data.token;
      } else {
        console.log('Token not found in response');
      }
    } else {
      console.log(`Error: ${resp.status} ${resp.statusText}`);
    }
  } catch (error) {
    console.error('Fetch error:', error);
  }
};
document.addEventListener('DOMContentLoaded', (event) => {
  keepTokenAlive(); // Refresh token on page load
  setInterval(keepTokenAlive, 15 * 60 * 1000); // Refresh token every 15 minutes
});
// END Csrf Token

//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);

const searchButton = true;

if(ie) {
  var imgContainer = document.querySelectorAll(".img-container");

  for(var i=0; i<imgContainer.length; i++){
    var imgCtr = imgContainer[i];
    var imgUrl = imgCtr.getElementsByTagName("img")[0].src;
    if (imgUrl) {
      imgCtr.setAttribute("style", "background-image:url('" + imgUrl + "')");
      imgCtr.classList.add("custom-object-fit");
    }
  }
}

function getOrdinalNum(n) {
  return n + (n > 0 ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10] : '');
}

function writeCookie(key, value, days) {
  let date = new Date();
  days = days || 7;
  date.setTime(+ date + (days * 86400000)); //24 * 60 * 60 * 1000
  window.document.cookie = key + "=" + value + "; expires=" + date.toGMTString() + "; path=/";
  return value;
}
function showLoader() {
  return true;
  document.body.classList.remove('loaded');
  document.querySelector('.loader svg#shape') ? document.querySelector('.loader svg#shape').classList.remove('active') : null;
  setTimeout(() => {
    document.querySelector('.loader svg#shape') ? document.querySelector('.loader svg#shape').classList.add('active') : null;
  }, 200);
}

// Back to top button
if(document.getElementById('back_to_top')) {
  const scrollToTopButton = document.getElementById('back_to_top');
  let smoothScrollCapture = (x) => {
    event.preventDefault();
    let id = x.currentTarget.target.getAttribute('href').split("#")[1]
    let el = document.getElementById(id);
    var x = el.getBoundingClientRect().left;
    var y = el.getBoundingClientRect().top;
    smoothScrollFunc(x, y)
  }
  let smoothScrollFunc = (x, y) => {
    event.preventDefault();
    window.scrollTo({
      top: y,
      left: x,
      behavior: 'smooth'
    });
  }
  window.addEventListener('DOMContentLoaded', () => {
    scrollToTopButton.addEventListener('click', () => {
      smoothScrollFunc(0, 0);
    })
  })
  window.addEventListener('scroll', () => {
    let pageHeight = document.body.scrollHeight;
    let currentHeight = window.scrollY;
    (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
  })
}

document.querySelectorAll('select').forEach(v => {
  v.addEventListener('change', (e) => {
    v.blur();
  })
})

// End back to top button

// Price toggles
let typeQueryString = document.body.dataset.type;
let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
let priceContainers = [].slice.call(document.querySelectorAll('.deal-price-toggle'));
let priceSwitchForm = document.getElementById('price-switch');
let selected;

allSwitches.forEach((value) => {
  value.addEventListener('click', (e) => {

  });
  value.addEventListener('change', (val) => {
    (val.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;
    if(val.composedPath()[0].classList.contains('price-toggle-checkbox')){
      (val.target.checked === true) ? selected = 1 : selected = 0;
    }
    toggleSwitches();
    togglePrices();
    updatePrice();
    hidePOA();
  })
})
let toggleSwitches = () => {
  allSwitches.forEach((v) => {
    (selected === 0) ? v.querySelectorAll('.toggle-personal').forEach((v) => { v.checked = true }) : v.querySelectorAll('.toggle-business').forEach((v) => { v.checked = true });
    (selected === 0) ? document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = false }) : document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = true });
  })
  document.querySelector("#switch-price-type") ? document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business' : null;
  document.querySelectorAll(".price-title-type").forEach((v) => {
    v.innerHTML = (selected === 0) ? 'Personal' : 'Business';
  })
}
let togglePrices = () => {
  priceContainers.forEach((v) => {
    if(v.querySelector('.price-personal')) {
      (selected === 0) ? v.querySelector('.price-personal').classList.add('active') : v.querySelector('.price-personal').classList.remove('active');
    }
    if(v.querySelector('.price-business')) {
      (selected === 1) ? v.querySelector('.price-business').classList.add('active') : v.querySelector('.price-business').classList.remove('active');
    }
  })
}

let updatePrice = () => {
  if (priceSwitchForm) {
    let url = priceSwitchForm.getAttribute('action');
    let formData = new FormData(priceSwitchForm);
    fetch(url, {
      method: 'POST',
      processData: false,
      contentType: false,
      body: formData,
      headers: {
        'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(
      function(response) {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        response.json().then(function(data) {
          document.querySelector("#price-switch [name=_token]").value = data.token;
        });
      }
    ).catch(function(err) {
      console.log('Fetch Error :-S', err);
    });
  }
}

let hidePOA = () => {
  let dealBoxes = document.querySelectorAll('.search .deal-box');
  if(dealBoxes.length > 0){
    priceContainers.forEach((v) => {
      if(v.querySelector('.price-personal')) {
        if(selected === 0){
          dealBoxes.forEach((el) => {
            if(el.dataset.poaPersonal == 'true' && !(el.classList.contains('hidden'))) {
              el.classList.add('hidden');
            } else if(el.dataset.poaPersonal == 'false' && el.classList.contains('hidden')) {
              el.classList.remove('hidden');
            }
          })
        } else {
          dealBoxes.forEach((el) => {
            if(el.dataset.poaBusiness == 'false' && el.classList.contains('hidden')) {
              el.classList.remove('hidden');
            }
          })
        }
      }
      if(v.querySelector('.price-business')) {
        if(selected === 1){
          dealBoxes.forEach((el) => {
            if(el.dataset.poaBusiness == 'true' && !(el.classList.contains('hidden'))) {
              el.classList.add('hidden');
            }
          })
        } else {
          // dealBoxes.forEach((el) => {
          //   if(el.dataset.poaBusiness == 'false' && el.classList.contains('hidden')) {
          //     // el.classList.remove('hidden');
          //     console.log('4')
          //   }
          // })
        }
      }
    })
  }
}

if (typeQueryString.toLowerCase().includes('personal') || typeQueryString.toLowerCase().includes('business')) {
  (typeQueryString.toLowerCase().includes('personal')) ? selected = 0 : null;
  (typeQueryString.toLowerCase().includes('business')) ? selected = 1 : null;
  toggleSwitches();
  togglePrices();
  updatePrice();
  hidePOA();
}
// End price Toggles

// Type Query
function containsQueryParam(paramName) {
  const url = new URL(window.location.href);
  return url.searchParams.has(paramName);
}
if (containsQueryParam('type')&&window.location.pathname!='/account/salsac/offers'){
  let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
  let selected = 0;
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  if (params.type == 'Personal') {
    selected = 0
  } else {
    selected = 1
  }
  allSwitches.forEach((v) => {
    (selected === 0) ? v.querySelectorAll('.toggle-personal').forEach((v) => { v.checked = true }) : v.querySelectorAll('.toggle-business').forEach((v) => { v.checked = true });
    (selected === 0) ? document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = false }) : document.querySelectorAll('.price-toggle-checkbox').forEach((v) => { v.checked = true });
  })
  document.querySelector("#switch-price-type").setAttribute('value', ((selected === 0) ? 'Personal' : 'Business'));
  document.querySelectorAll(".price-title-type").forEach((v) => {
    v.innerHTML = (selected === 0) ? 'Personal' : 'Business';
  })
  setTimeout(() => {
    let priceSwitchForm = [].slice.call(document.querySelectorAll('.price-toggle'));
    let url = priceSwitchForm[0].getAttribute('action');
    let formData = new FormData(priceSwitchForm[0]);
    fetch(url, {
      method: 'POST',
      processData: false,
      contentType: false,
      body: formData,
      headers: {
        'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(
      function(response) {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        response.json().then(function(data) {
          document.querySelector("#price-switch [name=_token]").value = data.token;
        });
      }
    ).catch(function(err) {
      console.log('Fetch Error :-S', err);
    });
  }, 800)
}
// End Type Query

function rangeTable() {

// Table Sorting
  function sortTable(elem, name, direction) {
    let sortName,sortDirection;
    if (name && direction) {
      sortName = name;
      sortDirection = direction;
    } else {
      sortName = elem.composedPath()[0].dataset.sortname;
      sortDirection = elem.composedPath()[0].dataset.sortdirection;
    }
    let tableBody = document.querySelector('.model-table-body');
    let tableRows = Array.from(tableBody.children);
    tableRows.pop();

    let sortRows = (dir) => [...tableRows].filter(row => (sortName !== 'price' && row.dataset[sortName].length) || (sortName === 'price' && row.dataset.price !== 'POA')).sort(function (a, b) {
      a = a.dataset[sortName];
      b = b.dataset[sortName];
      if (sortName === 'price') {
        return (dir === 'asc') ? b.localeCompare(a, 'en', {numeric: true}) : a.localeCompare(b, 'en', {numeric: true});
      }
      return (dir === 'asc') ? b.localeCompare(a) : a.localeCompare(b);
    });

    if (sortDirection.length && sortDirection === 'asc') {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      (name && direction) ? null : elem.composedPath()[0].setAttribute('data-sortdirection', 'desc');
      let sortTable = sortRows('desc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    } else {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      (name && direction) ? null : elem.composedPath()[0].setAttribute('data-sortdirection', 'asc');
      let sortTable = sortRows('asc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    }
  }

// Sort Model Table
  let sortHeaders = document.querySelectorAll('#model-table .model-table-head .table-sort[data-sortName]');
  [...sortHeaders].forEach((value) => value.addEventListener('click', (val) => sortTable(val)));

  let sortDropdown = document.querySelector('#table-sorter');
  if (sortDropdown) {
    sortDropdown.addEventListener('change', (e) => {
      (e.target.value === 'price_asc') ? sortTable(null, 'price', 'desc') : null;
      (e.target.value === 'price_desc') ? sortTable(null, 'price', 'asc') : null;
      (e.target.value === 'offers') ? sortTable(null, 'offer', 'asc') : null;
      (e.target.value === 'stock') ? sortTable(null, 'stock', 'asc') : null;
    })
  }

// Show no results text
  const showNoResults = function() {
    if(!document.querySelectorAll('.deal-box:not([class*="hidden"]):not(.no-results)').length > 0) {
      document.querySelector('.no-results').classList.remove('hidden-no-results', 'hidden');
    } else {
      document.querySelector('.no-results').classList.add('hidden-no-results');
    }
  }

// Show stock offers only
  let checkboxStock = document.querySelector('.stock [name=stock]');
  let modelNonStockDeals = document.querySelectorAll('#model-table .deal-box[data-stock="0"]');

  let inStockNum = document.querySelectorAll('#model-table .deal-box[data-stock="1"]').length;
  let allDealsNum = document.querySelectorAll('.deal-box:not([class*="hidden"]):not(.no-results)').length;
  let dealsAvailable = document.querySelector('#filters-form h3');

  if(checkboxStock && modelNonStockDeals){
    checkboxStock.addEventListener('change', (ev) => {
      if (ev.target.checked === true) {
        modelNonStockDeals.forEach((value) => {
          value.classList.add('visuallyhidden')
          showNoResults();
          dealsAvailable.innerHTML = `${inStockNum} Deals Available`;
        })
      } else {
        modelNonStockDeals.forEach((value) => {
          value.classList.remove('visuallyhidden')
          showNoResults();
          dealsAvailable.innerHTML = `${allDealsNum} Deals Available`;
        })
      }
    })
  }

// Model Table Search
  if (document.querySelector('#filters-form')) {
    let filterFields = document.querySelectorAll('#filters-form .filters input');
    const filterTable = (field, value) => {
      let searchType = field;

      if (value !== '' && value.length > 0) {
        let elements = document.querySelectorAll('.deal-box[data-' + searchType + ']');
        if (value.includes('-')) {
          let value_low = Number(value.split('-')[0]);
          let value_high = Number(value.split('-')[1]);
          elements.forEach((v) => {
            v.classList.add('hidden-' + field + '')
            let deal_box_value = Number(v.getAttribute('data-' + searchType + '').replace('£', ''))
            if(deal_box_value >= value_low && deal_box_value <= value_high) {
              v.classList.remove('hidden-' + field + '')
            }
          })
        } else {
          elements.forEach((v) => {
            v.classList.add('hidden-' + field + '')
            if(v.getAttribute('data-' + searchType + '').includes(value)) {
              v.classList.remove('hidden-' + field + '')
            }
          })
        }
      } else {
        document.querySelectorAll('.deal-box[data-' + searchType + ']').forEach((v) => {
          v.classList.remove('hidden-' + field + '')
        });
      }
      showNoResults();
    }
    if (filterFields) {
      filterFields.forEach((value => {
        value.addEventListener('change', (event) => {
          let val = value.value;
          let field = value.getAttribute('name');

          filterTable(field, val);

          if(val===field + "-any"){
            document.querySelectorAll('.deal-box[data-' + field + ']').forEach((v) => {
              v.classList.remove('hidden-' + field + '')
              showNoResults()
            });
          }
          dealsAvailable.innerHTML = `${document.querySelectorAll('.deal-box.deal-box-range:not([class*="hidden"])').length} Deals Available`;
        })
      }))
    }
  }
// End Model Table Search

// Model Table Search Mobile
//   if (document.querySelector('#filters-form-mobile')) {
//     let filterFields = document.querySelectorAll('#filters-form-mobile .filters input');
//     const filterTable = (field, value) => {
//       let searchType = field;
//
//       if (value !== '' && value.length > 0) {
//         let elements = document.querySelectorAll('.deal-box[data-' + searchType + ']');
//         elements.forEach((v) => {
//           v.classList.add('hidden-' + field + '')
//           if(v.getAttribute('data-' + searchType + '').includes(value)) {
//             v.classList.remove('hidden-' + field + '')
//           }
//         })
//       } else {
//         document.querySelectorAll('.deal-box[data-' + searchType + ']').forEach((v) => {
//           v.classList.remove('hidden-' + field + '')
//         });
//       }
//
//       // Show no results text
//       showNoResults();
//     }
//     if (filterFields) {
//       filterFields.forEach((value => {
//         value.addEventListener('change', (event) => {
//           let val = value.value;
//           let field = value.getAttribute('name');
//
//           filterTable(field, val);
//
//           if(val===field +"-any"){
//             document.querySelectorAll('.deal-box[data-' + field + ']').forEach((v) => {
//               v.classList.remove('hidden-' + field + '')
//               showNoResults()
//             });
//           }
//         })
//       }))
//     }
//   }
// End Model Table Search Mobile

// Model Table Terms
  function loadTablePrices(vehicleType, vehicleIds) {
    let priceView = document.querySelector('#switch-price-type').value;
    let term = document.querySelector('.range-filters [name="term"]');
    let profile = document.querySelector('.range-filters [name="profile"]');
    let mileage = document.querySelector('.range-filters [name="mileage"]');

    document.querySelectorAll('.deal-box-price .price-amount p.active').forEach(element => element.classList.add('price-loader'));
    // document.querySelectorAll('.filter-form-terms').forEach(element => element.parentElement.parentElement.parentElement.classList.add('filter-loader'));
    if (vehicleType && vehicleIds && term && profile && mileage && priceView) {
      let url = `/api/${vehicleType}/price/bulk?${vehicleIds}term=${term.value}&initial_profile=${profile.value}&mileage=${mileage.value}&price_view=${priceView}`;
      fetch(url, {
        method: 'GET',
        // body: formData,
      }).then(function (response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function (data) {
        if(data){
          data.forEach((v, i) => {
            if (v) {
              if (vehicleType === 'van') {
                document.querySelector(`.deal-box[data-id="${v.van_id}"] .deal-box-price .price-amount > p.active > span.price`).innerHTML = (v.monthly_rental) ? `£${v.monthly_rental.toLocaleString("en",{useGrouping: false,minimumFractionDigits: 2})}` : 'POA';
                document.querySelector(`.deal-box[data-id="${v.van_id}"]`).setAttribute('data-price', ((v.monthly_rental) ? `£${v.monthly_rental.toLocaleString("en",{useGrouping: false,minimumFractionDigits: 2})}` : 'POA'));
              } else {
                document.querySelector(`.deal-box[data-id="${v.car_id}"] .deal-box-price .price-amount > p.active > span.price`).innerHTML = (v.monthly_rental) ? `£${v.monthly_rental.toLocaleString("en",{useGrouping: false,minimumFractionDigits: 2})}` : 'POA';
                document.querySelector(`.deal-box[data-id="${v.car_id}"]`).setAttribute('data-price', ((v.monthly_rental) ? `£${v.monthly_rental.toLocaleString("en",{useGrouping: false,minimumFractionDigits: 2})}` : 'POA'));
              }
            } else {
              document.querySelector(`.deal-box:nth-child(${i+1}) .deal-box-price .price-amount > p.active > span.price`).innerHTML = 'POA';
            }
          })
          // document.querySelector('#filters-form .filters input[name="price"]:checked').dispatchEvent(new Event('change'));
          document.querySelectorAll('.deal-box-price .price-amount p.active').forEach(element => element.classList.remove('price-loader'));
          // document.querySelectorAll('.filter-form-terms').forEach(element => element.parentElement.parentElement.parentElement.classList.remove('filter-loader'));
        }
      }).catch(function (err) {
        console.error('Fetch Error -', err);
      });
    }
  }
  if (document.querySelector('.range-filters') && document.querySelector('.model-table-body > div')) {
    let tableRows = document.querySelectorAll('.model-table-body > div:not(.no-results)');
    let vehicleIds = '';
    let vehicleType = document.querySelector('.model-table-body > div:not(.no-results)').dataset.type;
    tableRows.forEach(v => {
      vehicleIds += `ids[]=${v.dataset.id}&`
    })

    loadTablePrices(vehicleType, vehicleIds)
    document.querySelectorAll('.range-filters .search-results-form-terms select').forEach(value => {
      value.addEventListener('change', e => {
        loadTablePrices(vehicleType, vehicleIds)
      })
    })
  }
// End Model Table Terms
}
rangeTable()

if (document.querySelector('#manufacturer_lookup')) {
  document.querySelector('#manufacturer_lookup').addEventListener('focus', (ev) => {
    if (!ev.target.classList.contains('loaded')) {
      let type = ev.target.dataset.type;
      let target = ev.target
      let url = `/api/${type}/manufacturers/ev`;
      let params = '?' + new URLSearchParams({'available': 'yes'})
      fetch(url + params).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.setAttribute('data-url', `/${type}-leasing/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}`);
          option.setAttribute('value', `${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}`);
          option.text = `${data[keysSorted[x]].toUpperCase()}`;
          target.appendChild(option);
        }
        ev.target.classList.add('loaded');
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    }
  })
}

//Nav Toggle
// function toggleNav(el) {
//     var element = el;
//     var menu = document.getElementById("site-menu");
//     var header = document.querySelectorAll(".site-header")[0];
//     menu.classList.toggle("active");
//     header.classList.toggle("active");
//
//     if(element.querySelector("span").classList.contains("more")){
//       element.innerHTML = "<span class='close'></span> Close";
//     } else {
//       element.innerHTML = "<span class='more'></span> Menu";
//     }
// }


// Toggle Search Bar
document.addEventListener("DOMContentLoaded", function() {
  let searchButton = document.querySelector('#toggle-search');
  if(searchButton){
    searchButton.addEventListener('click', () => {
      document.querySelector('.search-bar-hero').classList.toggle('visible');
    });
  }
});


function loadManufacturersNav($el) {
  if ($el) {
    $el.forEach(v => {
      if (!v.classList.contains('loaded')) {
        let type = v.dataset.id;
        let target = document.querySelector(`.slideout-navigation [data-dropdown=${type}]`)
        let url = `/api/${type}/manufacturers/`;
        let params = '?' + new URLSearchParams({'available': 'yes'})
        fetch(url + params).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            let link = document.createElement('a');
            link.setAttribute('href', `/${type}-leasing/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}`);
            link.innerHTML = `${data[keysSorted[x]].toUpperCase()} <img src="/themes/jurni/img/manufacturer/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}.svg" alt="${keysSorted[x]}" width="26" height="26" onerror="this.style.display='none'">`;
            target.appendChild(link)
          }
          v ? v.classList.add('loaded') : null;
        }).catch(function(err) {
          console.error('Fetch Error -', err);
        });
      }
    })
  }
}

// Navigation Sticky Scroll
let lastScroll = 0;
window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 100) {
    document.body.classList.remove('scroll-up');
    return;
  }
  if (currentScroll > lastScroll && !document.body.classList.contains('scroll-down')) {
    document.body.classList.remove('scroll-up');
    document.body.classList.add('scroll-down');
  } else if (
    currentScroll < lastScroll &&
    document.body.classList.contains('scroll-down')
  ) {
    document.body.classList.remove('scroll-down');
    document.body.classList.add('scroll-up');
  }
  lastScroll = currentScroll;
});

// Toggle Nav Sidebar
document.querySelector('.slideout-navigation-toggle') ? document.querySelectorAll('.slideout-navigation-toggle').forEach((value) => {
  value.addEventListener('click', () => {
    document.body.classList.toggle('slideout-navigation-active');
    loadManufacturersNav(document.querySelectorAll('.slideout-navigation [data-manufacturers]'))
  })
}) : null;
// Close Nav Sidebar
document.querySelector('.slideout-navigation-close') ? document.querySelectorAll('.slideout-navigation-close').forEach((value) => {
  value.addEventListener('click', () => {
    document.body.classList.remove('slideout-navigation-active');
  })
}) : null;
document.querySelectorAll('.burger-navigation-main > a[data-id]').forEach(value => {
  value.addEventListener('click', (ev) => {
    document.querySelectorAll('.burger-navigation-main > a[data-id]').forEach(v => {
      (v !== ev.target) ? v.classList.remove('active') : null;
      (v !== ev.target) ? v.nextElementSibling.classList.remove('active') : null;
    })
    ev.target.classList.toggle('active');
    (ev.target.nextElementSibling.dataset.dropdown === ev.target.dataset.id) ? ev.target.nextElementSibling.classList.toggle('active') : null;
  })
})
document.querySelectorAll('.burger-navigation-sub-1 > a[data-id]').forEach(value => {
  value.addEventListener('click', (ev) => {
    document.querySelectorAll('.burger-navigation-sub-1 > a[data-id]').forEach(v => {
      (v !== ev.target) ? v.classList.remove('active') : null;
      (v !== ev.target) ? v.nextElementSibling.classList.remove('active') : null;
    })
    ev.target.classList.toggle('active');
    (ev.target.nextElementSibling.dataset.dropdown === ev.target.dataset.id) ? ev.target.nextElementSibling.classList.toggle('active') : null;
  })
})
document.querySelectorAll('.burger-navigation-sub-2 > a[data-id]').forEach(value => {
  value.addEventListener('click', (ev) => {
    document.querySelectorAll('.burger-navigation-sub-2 > a[data-id]').forEach(v => {
      (v !== ev.target) ? v.classList.remove('active') : null;
      (v !== ev.target) ? v.nextElementSibling.classList.remove('active') : null;
    })
    ev.target.classList.toggle('active');
    (ev.target.nextElementSibling.dataset.dropdown === ev.target.dataset.id) ? ev.target.nextElementSibling.classList.toggle('active') : null;
  })
})
document.querySelectorAll('.burger-navigation-sub-3-open').forEach(value => {
  value.addEventListener('click', (ev) => {
    ev.target.classList.remove('active');
    document.querySelector('.burger-navigation-main').classList.remove('active');
    document.querySelector(`.burger-navigation-sub-3[data-dropdown=${value.dataset.id}]`).classList.add('active');
  })
})
document.querySelectorAll('.burger-navigation-sub-3-close').forEach(value => {
  value.addEventListener('click', (ev) => {
    ev.target.classList.remove('active');
    document.querySelector('.burger-navigation-main').classList.add('active');
    document.querySelectorAll('.burger-navigation-sub-3').forEach(v => { v.classList.remove('active'); })
  })
})

/* MOBILE MODALS */
// const navContainer = document.querySelector('.nav-container');
// const hamburger = document.querySelector('#hamburger');
// const hamburgerSearch = document.querySelector('#headerSearch');
//
// const modalMobileNav = new tingle.modal({
//   footer: false,
//   closeMethods: ['escape'],
//   cssClass: ['mobile-nav','reversed'],
//   onOpen: function () {
//     // Navigation height
//     let headerHeight = 0;
//     if (document.querySelector('.site-header').classList.contains('is-sticky')) {
//       headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight;
//     } else {
//       headerHeight = document.querySelector('.site-header').offsetHeight + document.querySelector('.top-bar').offsetHeight + (document.body.getBoundingClientRect().top + window.scrollY);
//     }
//     document.querySelector('.mobile-nav.tingle-modal').setAttribute('style', `margin-top:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
//     // document.querySelector('.site-menu') ? modalMobileNav.setFooterContent(document.querySelector('#price-switch').outerHTML) : null;
//     // priceToggles();
//   }
// });
// document.querySelector('.site-menu') ? modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML) : null;
//
// // Nav modal
// const handleToggle = () => {
//   hamburger.classList.toggle('active');
//   hamburger.classList.toggle('is-active');
//   navContainer.classList.toggle('is-active');
//   // hamburger.parentElement.classList.toggle('active');
//
//   if(hamburger.classList.contains("active")) {
//     // modalMobileSearch.close();
//     modalMobileNav.open();
//   } else{
//     modalMobileNav.close();
//   }
// }
//
// hamburger.onclick = () => handleToggle();
// hamburger.addEventListener('keyup', (event) => {
//   if(event.keyCode === 13 || event.keyCode === 32) {
//     handleToggle();
//   }
// });
/* END MOBILE MODALS */

// Sticky class for navbar & modal
// window.onscroll = function() { stickyNav() };
// let page = document.querySelector('#page');
// let navbar = document.getElementById('navbar');
// let sticky = navbar.offsetTop;
// function stickyNav() {
//   if (!document.body.classList.contains('tingle-enabled')) {
//     if (window.pageYOffset >= sticky) {
//       (page) ? page.style.paddingTop = '120px' : null;
//       navbar.classList.add('is-sticky');
//     } else {
//       (page) ? page.style.paddingTop = '0' : null;
//       navbar.classList.remove('is-sticky');
//     }
//   }
// }
// window.addEventListener("orientationchange", function() {
//   (page) ? page.style.paddingTop = '0' : null;
//   navbar.classList.remove('is-sticky');
// }, false);

// Review Video Modals
const videoButton = document.querySelectorAll('.deal-gallery-main.video-trigger');
const videoModal = new tingle.modal({
  footer: false,
  closeMethods: ['overlay', 'button', 'escape'],
  closeLabel: "Close",
  cssClass: ['video-modal'],
  onClose: function() {
    this.setContent('');
  }
});
videoButton.forEach((value) => {
  value.addEventListener("click", function(e){
    const videoWrapper = document.querySelector('#review-video');
    const videoWrapperClone = videoWrapper.cloneNode(true);
    if (videoWrapperClone) {
      videoModal.setContent(videoWrapperClone);
      videoModal.open();
      videoWrapperClone.querySelector('video').play();
    }
  })
})
// END Review Video Modals

// Search Bar
var searchDropdown = function(){
  var searchRow = this.closest('.search-bar');
  searchRow.classList.toggle("active");
}

var searchBar = document.querySelectorAll(".search-bar .legend");

for(var i=0; i<searchBar.length; i++){
  searchBar[i].addEventListener('click', searchDropdown, false);
}


if(document.getElementsByClassName('toggle-search').length>0){
  document.getElementsByClassName('toggle-search')[0].addEventListener('click', function(e){
    e.preventDefault();
    if(document.querySelector('#popout-form')===null){
      window.location.href='/search';
      return false;
    }
    if(document.querySelector('#popout-form').classList.contains('hidden')){
      document.querySelector('#popout-form').classList.remove('hidden');
    } else {
      document.querySelector('#popout-form').classList.add('hidden');
    }
  });
}

function searchSorter() {
  let searchSorter = document.querySelector('#search-sorter');
  if (searchSorter) {
    searchSorter.addEventListener('change', (e) => {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('order', e.target.value);
      if ((e.target.value === 'price_asc' || e.target.value === 'price_desc') && !window.location.search.includes('initial_profile')) {
        urlParams.set('initial_profile', e.target.dataset.profile);
      }
      window.location.search = urlParams;
    })
  }
}
searchSorter();

// Show More
const showMoreButton = document.querySelector('#show-more');
const headerContent = document.querySelector('.header-content');
if(showMoreButton){
  if (showMoreButton.parentElement.parentElement.querySelectorAll('.header-description > *')) {
    showMoreButton.addEventListener('click', (e) => {
      // console.log('click')
      headerContent.classList.toggle('header-content--full');
      showMoreButton.classList.toggle('active');
      (showMoreButton.classList.contains('active')) ? showMoreButton.querySelector('span').innerText = 'Show less' : showMoreButton.querySelector('span').innerText = 'Read more';
    })
  } else {
    showMoreButton.classList.add('visuallyhidden')
  }
}
// END Show More


//Menu Dropdown Toggle
// var menuDropdown = function(){
//     var dropdown = this;
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }

// //Dropdown Button
// var showDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var dropdownButton = document.querySelectorAll(".dropdown > button");

// for(var i=0; i<dropdownButton.length; i++){
//   dropdownButton[i].addEventListener('click', showDropdown, false);
// }

// //Dropdown Toggle
// var showDropdown = function(){
//     var dropdown = this.querySelector('div');
//     dropdown.classList.toggle("active");
// }

// var has_dropdown = document.querySelectorAll(".has-dropdown");

// for(var i=0; i<has_dropdown.length; i++){
//   has_dropdown[i].addEventListener('click', showDropdown, false);
// }

// // Mobile Dropdown
// var mobileDropdown = function(){
//     var dropdown = this.parentNode;
//     dropdown.classList.toggle("active");
// }

// var mobile_dropdown = document.querySelectorAll(".breadcrumb-menu");

// for(var i=0; i<mobile_dropdown.length; i++){
//   mobile_dropdown[i].addEventListener('click', mobileDropdown, false);
// }


// Site Search Toggle
// var searchToggle = function(){
//   search_container = document.querySelector(".popout-form");
//   if(search_container){
//     search_container.classList.toggle("active");
//   } else {
//     var elmnt = document.querySelector(".full-header-search");
//     elmnt.scrollIntoView();
//   }
// }

// var search_toggle = document.getElementById('search-toggle');
// search_toggle.addEventListener('click', searchToggle , false);



//Site Menu Dropdown Toggle
var menuDropdown = function(){
  //div inside element contains dropdown menu
  var dropdown = this.parentNode;

  //if it's already active set it not to be
  if(dropdown.classList.contains("active")){
    dropdown.classList.toggle("active");
    return;
  }
  //get current active class
  var activeClass = document.querySelectorAll(".menu-dropdown.active");
  // make it not active
  if(activeClass!=null){
    for(var i=0; i<activeClass.length; i++){
      activeClass[i].classList.toggle("active");
    }
  }

  //apply active to the div inside element that contains dropdown menu
  dropdown.classList.toggle("active");
}

var dropdownTrigger = document.querySelectorAll(".menu-dropdown > a");

for(var i=0; i<dropdownTrigger.length; i++){
  dropdownTrigger[i].addEventListener('click', menuDropdown, false);
}


// //Menu Dropdown Toggle
// var menuDropdown = function(){
//     //div inside element contains dropdown menu
//     var dropdown = this.parentNode.querySelector(".menu-dropdown");

//     //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     // //get current active class
//     // var activeClass = document.querySelectorAll(".menu-dropdown.active");
//     // // make it not active
//     // if(activeClass!=null){
//     //     for(var i=0; i<activeClass.length; i++){
//     //       activeClass[i].classList.toggle("active");
//     //     }
//     // }

//     //apply active to the div inside element that contains dropdown menu
//     dropdown.classList.toggle("active");
// }

// var menuTrigger = document.querySelectorAll(".menu-dropdown > a");

// for(var i=0; i<menuTrigger.length; i++){
//   menuTrigger[i].addEventListener('click', menuDropdown, false);
// }


//Dropdown Menu Toggle
var showMenu = function(){
  //div inside element contains dropdown menu
  var dropdown = this.parentNode.querySelector('div');
  var menuToggle = this;

  //if it's already active set it not to be
  if(dropdown.classList.contains("active")){
    dropdown.classList.toggle("active");
    menuToggle.classList.toggle("active");
    dropdown.classList.toggle("is-active");
    menuToggle.classList.toggle("is-active");
    return;
  }
  //get current active class
  var activeClass = document.querySelectorAll(".dropdown-menu .active");
  // make it not active
  if(activeClass!=null){
    for(var i=0; i<activeClass.length; i++){
      activeClass[i].classList.toggle("active");
      activeClass[i].classList.toggle("is-active");
    }
  }

  //apply active to the div inside element that contains dropdown menu
  dropdown.classList.toggle("active");
  dropdown.classList.toggle("is-active");
  menuToggle.classList.toggle("active");
  menuToggle.classList.toggle("is-active");
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
  menuDropdown[i].addEventListener('click', showMenu, false);
}
// Toggle Compare Nav Dropdown
document.querySelector('.compare-btn>a').addEventListener('click', (e)=>{ e.target.parentElement.classList.toggle('active') })

// Toggle class for accordions
function toggleAccordions() {
  let acc = document.getElementsByClassName('mobile-accordion-header');
  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function(ev) {

      for (let i = 0; i < acc.length; i++) {
        if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
          continue;
        }
        acc[i].parentElement.classList.remove('active');
      }

      if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
        setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
      }
      this.parentElement.classList.toggle("active");

    });
  }
}
toggleAccordions();


//Dropdown Menu Toggle
// var mobileDropdown = function(){
//   //div inside element contains dropdown menu
//   var dropdown = this.parentNode.querySelector('div');


//   //if it's already active set it not to be
//     if(dropdown.classList.contains("active")){
//         dropdown.classList.toggle("active");
//         return;
//     }
//     //get current active class
//     var activeClass = document.querySelectorAll(".mobile-dropdown .active");
//     // make it not active
//     if(activeClass!=null){
//         for(var i=0; i<activeClass.length; i++){
//           activeClass[i].classList.toggle("active");
//         }
//     }


//   //apply active to the div inside element that contains dropdown menu
//   dropdown.classList.toggle("active");
// }

// var mobileMenu = document.querySelectorAll(".mobile-dropdown > a");

// for(var i=0; i<mobileMenu.length; i++){
//   mobileMenu[i].addEventListener('click', mobileDropdown, false);
// }


//More Options Toggle
var classname = document.querySelectorAll(".more-options");

var moreOptions = function(e) {
  e.preventDefault();
  var element = document.getElementById("vehicle-search");
  element.classList.toggle("active");
  if(element.classList.contains('active')){
    this.innerHTML = 'Hide additional options';
  } else {
    this.innerHTML = 'Show me more options';
  }
};

for (var i = 0; i < classname.length; i++) {
  classname[i].addEventListener('click', moreOptions, false);
}

// Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  var targetContent = document.getElementById(tabName);
  var targetTab = e.currentTarget;

  // Check if already active
  var isActive = targetContent.classList.contains("active");

  // If active, remove active classes
  if (isActive) {
    targetContent.className = targetContent.className.replace(" active", "");
    targetTab.className = targetTab.className.replace(" active", "");
  } else {
    // Remove active classes from all tabs
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].className = tabcontent[i].className.replace(" active", "");
    }
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    // Activate the clicked tab
    targetContent.className += " active";
    targetTab.className += " active";
  }
}


function showOptions(e, tabName) {
  e.preventDefault();
  document.querySelector(tabName).classList.toggle("active");
}


// SEARCH SIDEBAR
function setUrlParams(param, value, module) {
  let searchUrl = new URL(window.location.origin + window.location.pathname);
  if (module === 'Search') {
    if (window.location.search.includes('offers=specials')) {
      searchUrl.searchParams.set('offers', 'specials');
    } else if (window.location.search.includes('offers=stock')) {
      searchUrl.searchParams.set('offers', 'stock');
    }
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', document.querySelector('#search-type').value);
  } else if (window.location.pathname === '/car-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
  } else if (window.location.pathname === '/special-offers') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
    searchUrl.searchParams.set('offers', 'specials');
  } else if (window.location.pathname === '/stock') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
    searchUrl.searchParams.set('offers', 'stock');
  } else if (window.location.pathname === '/van-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
  } else if (window.location.pathname === '/van-leasing/special-offers') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    searchUrl.searchParams.set('offers', 'specials');
  } else if (window.location.pathname === '/van-leasing/stock') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    searchUrl.searchParams.set('offers', 'stock');
  } else if (window.location.pathname === '/pick-up-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    searchUrl.searchParams.append('body_type', 'Pick-up');
  } else {
    (value==='van') ? searchUrl = new URL(window.location.origin + '/van-leasing' + window.location.pathname) : null;
    (value==='car') ? searchUrl = new URL(window.location.origin + (window.location.pathname).replace('/van-leasing', '')) : null;
    searchUrl.searchParams.set('filter', 'true');
  }
  if(param==='type'){
    searchUrl.searchParams.set('search-type', value);
    searchUrl.searchParams.set('make', '');
    searchUrl.searchParams.set('model', '');
    searchUrl.searchParams.delete('van_size');
    searchUrl.searchParams.delete('body_type');
  } else {
    searchUrl.searchParams.set('make', param==='make' ? value : (document.querySelector('.search-aside input[name="make"]:checked') ? document.querySelector('.search-aside input[name="make"]:checked').value : ''));
    searchUrl.searchParams.set('model', param==='model' ? value : (document.querySelector('.search-aside input[name="model"]:checked') ? document.querySelector('.search-aside input[name="model"]:checked').value : ''));
    // param==='make' ? searchUrl.searchParams.set('model', '') : null;

    if(window.location.pathname !== '/pick-up-leasing'){
      searchUrl.searchParams.set('van_size', (param==='van_size') ? value : (document.querySelector('.search-aside input[name="van_size"]:checked') ? document.querySelector('.search-aside input[name="van_size"]:checked').value : ''));
      searchUrl.searchParams.set('body_type', (param==='body_type') ? value : (document.querySelector('.search-aside input[name="body_type"]:checked') ? document.querySelector('.search-aside input[name="body_type"]:checked').value : ''));
    }

    if(param==='make'){
      searchUrl.searchParams.delete('model');
      searchUrl.searchParams.delete('van_size');
      searchUrl.searchParams.delete('body_type');
    }
    if(param==='model'){
      searchUrl.searchParams.delete('van_size');
      searchUrl.searchParams.delete('body_type');
    }
    if(param==='van_size'){
      searchUrl.searchParams.delete('body_type');
    }
    if(param==='body_type'){
      searchUrl.searchParams.delete('van_size');
    }
  }

  let updatedMin = document.querySelector('.search-aside #budget-slider .noUi-handle-lower').getAttribute('data-value');
  let updatedMax = document.querySelector('.search-aside #budget-slider .noUi-handle-upper').getAttribute('data-value');
  if(isNaN(updatedMax) && updatedMin == '0') {
     searchUrl.searchParams.delete('budget');
  } else if(isNaN(updatedMax) && updatedMin != '0') {
    searchUrl.searchParams.set('budget', param==='budget' ? value : (updatedMin + '+'));
  } else{
    searchUrl.searchParams.set('budget', param==='budget' ? value : (updatedMin + '-' + updatedMax));
  }
  searchUrl.searchParams.set('fuel_type', param==='fuel_type' ? value : (document.querySelector('.search-aside input[name="fuel_type"]:checked') ? document.querySelector('.search-aside input[name="fuel_type"]:checked').value : ''));
  searchUrl.searchParams.set('transmission', param==='transmission' ? value : (document.querySelector('.search-aside input[name="transmission"]:checked') ? document.querySelector('.search-aside input[name="transmission"]:checked').value : ''));
  searchUrl.searchParams.set('seats', param==='seats' ? value : (document.querySelector('.search-aside input[name="seats"]:checked') ? document.querySelector('.search-aside input[name="seats"]:checked').value : ''));

  searchUrl.searchParams.set('term', param==='term' ? value : (document.querySelector('.search-filters [name="term"]') ? document.querySelector('.search-filters [name="term"]').value : ''));
  searchUrl.searchParams.set('initial_profile', param==='initial_profile' ? value : (document.querySelector('.search-filters [name="initial_profile"]') ? document.querySelector('.search-filters [name="initial_profile"]').value : ''));
  searchUrl.searchParams.set('mileage', param==='mileage' ? value : (document.querySelector('.search-filters [name="mileage"]') ? document.querySelector('.search-filters [name="mileage"]').value : ''));

  searchUrl.searchParams.set('order', param==='order' ? value : (document.querySelector('.search-filters select[name="order"]') ? document.querySelector('.search-filters select[name="order"]').value : ''));

  window.location.href = searchUrl;
}

const saveSearchButton = document.querySelector('#save_search_btn');
// let cookie = Cookies.get('savedSearches');
// if (cookie) {
//   let cookie_obj = JSON.parse(cookie);
//   console.log(cookie_obj);
// }
// function saveSearch(url) {
//   // writeCookie('savedSearches', url)
//   let cookie_obj = JSON.parse(url);
//   Cookies.set('savedSearches', JSON.stringify(cookie_obj))
//   console.log(url);
//   console.log(new URLSearchParams(url).get('make'));
// }
// if (saveSearchButton) {
//   saveSearchButton.addEventListener('click', () => {
//     saveSearch(window.location.href);
//     saveSearchButton.classList.toggle('active');
//   })
// }
document.querySelectorAll('button[data-saved]').forEach((value) => {
  value.addEventListener('click', (e) => {
    e.preventDefault();
    let cookie = Cookies.get('saved_searches')
    if (cookie) {
      let cookie_obj = JSON.parse(cookie);
      if (cookie_obj[e.target.dataset.saved] === undefined) {
        if (Object.keys(cookie_obj).length < 30) {
          cookie_obj = {...cookie_obj, [e.target.dataset.saved] : e.target.dataset.name};
          let cookie_string = JSON.stringify(cookie_obj);
          Cookies.set('saved_searches', cookie_string);
          e.target.dataset.savedAdded = 'true';
          e.target.classList.add('active');
          alertify.confirm('Saved Searches')
            .setting({
              'title': 'Your Saved Searches',
              'message': `Search parameters saved.`,
              'labels': { ok: 'Go To Saved Searches', cancel: 'Close' },
              'onok': function(){ window.location.href = "/saved" }
            });
        } else {
          alertify.confirm('Your Saved Searches')
            .setting({
              'title': 'Your Saved Searches',
              'message': `
                  <span class="semi-bold">Saved Searches list full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items on your saved search list.</span>
                `,
              'labels': { ok: 'Go To Saved Searches', cancel: 'Close' },
              'onok': function(){ window.location.href = "/saved" }
            });
        }
      } else {
        delete cookie_obj[e.target.dataset.saved];
        (Object.keys(cookie_obj).length !== 0) ? Cookies.set('saved_searches', JSON.stringify(cookie_obj)) : Cookies.remove('saved_searches');
        e.target.dataset.savedAdded = 'false';
        document.querySelector('.tools-main') ? e.target.closest('.deal-box').remove() : null;
        e.target.classList.remove('active');
        alertify.confirm('Your Saved Searches')
          .setting({
            'title': 'Your Saved Searches',
            'message': `Search parameters removed from  saved searches`,
            'labels': { ok: 'Go To Saved Searches', cancel: 'Close' },
            'onok': function(){ window.location.href = "/saved" }
          });
      }
    } else {
      let cookie_obj = JSON.parse(`{"${e.target.dataset.saved}":"${e.target.dataset.name}"}`);
      let cookie_string = JSON.stringify(cookie_obj);
      Cookies.set('saved_searches', cookie_string);
      e.target.dataset.savedAdded = 'true';
      e.target.classList.add('active');
      alertify.confirm('Your Saved Searches')
        .setting({
          'title': 'Your Saved Searches',
          'message': `Search parameters added to saved searches`,
          'labels': { ok: 'Go To Saved Searches', cancel: 'Close' },
          'onok': function(){ window.location.href = "/saved" }
        });
    }
  })

})

// Show Only Filters
function updateSearchToggles() {
  let searchToggles = document.querySelectorAll('.search-form .stock input');
  if (searchToggles) {
    if (!searchButton) {
      searchToggles.forEach(value => {
        value.addEventListener('change', (e) => {
          let searchUrl = new URL(window.location.origin + '/car-leasing');
          let vans = (window.location.pathname.includes('van-leasing') || window.location.search.includes('search-type=van')) ? '/van-leasing' : '';
          (window.location.pathname.includes('van-leasing')) ? searchUrl = new URL(window.location.origin + '/van-leasing') : null;
          (e.target.value === 'stock' && e.target.checked) ? searchUrl = new URL(window.location.origin + vans + '/stock') : null;
          (e.target.value === 'stock' && e.target.checked && e.target.dataset.module === 'Electric.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Electric') : null;
          (e.target.value === 'stock' && e.target.checked && e.target.dataset.module === 'Hybrid.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Hybrid') : null;
          (e.target.value === 'stock' && e.target.checked && window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=', 'offers=stock')) : null;
          (e.target.value === 'stock' && e.target.checked && window.location.pathname==="/search" && !window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('?', '?offers=stock&')) : null;
          (e.target.value === 'stock' && e.target.checked && window.location.search.includes('offers=&')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=&', 'offers=stock&')) : null;
          (e.target.value === 'stock' && !e.target.checked && window.location.search.includes('offers=stock')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=stock', 'offers=')) : null;
          showLoader();
          window.location.href = searchUrl;
        })
      })
    }
  }
}
// END Show Only Filters

if (searchButton){
  document.querySelectorAll('.search-aside input[name="search_type"]').forEach(v => {
    v.addEventListener('change', e => {
      document.querySelectorAll('#make-wrapper input').forEach(v => { v.checked = false })
      document.querySelector('.search-aside #search-type').value = document.querySelector('.search-aside input[name="search_type"]:checked').value;
      let type = document.querySelector('.search-aside #search-type').value;
      loadManufacturersRadio(type);
    })
  })
}

function loadSearchTriggers() {
  // console.log("loadSearchTriggers");
  if (document.querySelector('.search-aside') && document.querySelector('.search-filters')) {

    let selectedMake = document.querySelector('.search-aside input[name="make"]:checked');

    if (searchButton){
      document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
        v.addEventListener('change', e => {
          selectedMake = document.querySelector('.search-aside input[name="make"]:checked');
          document.querySelectorAll('.model-wrapper').forEach(v => { v.innerHTML = ''; v.classList.remove('show'); })
          loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);
          let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
          (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
        })
      })
    }

    if (document.querySelector('.search-aside #search-type')) {

      // Show Models for selected manufacturer
      if (selectedMake) {
        loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);

        let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
        (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
        console.log(".3");
      }

      if(document.querySelector('.search-aside #body_type-wrapper')){
        loadBodyTypesRadio(document.querySelector('.search-aside #search-type').value);
      }
      if(document.querySelector('.search-aside #fuel_type-wrapper')){
        loadFuelTypesRadio(document.querySelector('.search-aside #search-type').value);
      }
      if(document.querySelector('.search-aside #transmission-wrapper')){
        loadTransmissionTypesRadio(document.querySelector('.search-aside #search-type').value);
      }

      (document.querySelector('.button-clear')) ? null : document.querySelector('.clear-filters').classList.add('visuallyhidden');

      if(!searchButton) {
        document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
          v.addEventListener('change', e => {
            showLoader();
            document.querySelector('.search-aside .model-wrapper [name="model"]:checked') ? document.querySelector('.search-aside .model-wrapper.show [name="model"]:checked').checked = false : null;
            setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside [name="model"]').forEach(v => {
          v.addEventListener('change', e => {
            showLoader();
            setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside [name="van_size"]').forEach(v => {
          v.addEventListener('change', e => {
            showLoader();
            //remove bodytype
            document.querySelector('.search-aside [name="body_type"]:checked') ? document.querySelector('.search-aside [name="body_type"]:checked').checked = false : null;
            setUrlParams('van_size', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside [name="body_type"]').forEach(v => {
          v.addEventListener('change', e => {
            showLoader();
            //remove van size
            document.querySelector('.search-aside [name="van_size"]:checked') ? document.querySelector('.search-aside [name="van_size"]:checked').checked = false : null;
            setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
            // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
          })
        })
        // document.querySelectorAll('.search-aside input[name="budget"]').forEach(v => {
        //   v.addEventListener('change', e => {
        //     showLoader();
        //     setUrlParams('budget', e.target.value, document.querySelector('.search-content').dataset.module);
        //   })
        // })
        document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
          v.addEventListener('change', e => {
            showLoader();
            setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
            // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
          })
        })
        document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
          v.addEventListener('change', e => {
            showLoader();
            setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside input[name="seats"]').forEach(v => {
          v.addEventListener('change', e => {
            showLoader();
            setUrlParams('seats', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside input[name="search_type"]').forEach(v => {
          v.addEventListener('change', e => {
            showLoader();
            setUrlParams('type', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        if (document.querySelector('.search-filters select[name="order"]')) {
          document.querySelector('.search-filters select[name="order"]').addEventListener('change', e => {
            showLoader();
            setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        }
      }
      document.querySelectorAll('.search-filters [name="term"]').forEach(v => {
        v.addEventListener('change', e => {
          showLoader();
          setUrlParams('term', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })
      document.querySelectorAll('.search-filters [name="initial_profile"]').forEach(v => {
        v.addEventListener('change', e => {
          showLoader();
          setUrlParams('initial_profile', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })
      document.querySelectorAll('.search-filters [name="mileage"]').forEach(v => {
        v.addEventListener('change', e => {
          showLoader();
          setUrlParams('mileage', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })

      if (document.querySelector('.button-clear[data-type="make"]') && selectedMake) {
        document.querySelector('.button-clear[data-type="make"] > span.text-inner').innerText = selectedMake.nextElementSibling.nextElementSibling.textContent;
      }

      if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
        document.querySelector('.button-clear[data-type="model"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="model"]:checked').nextElementSibling.nextElementSibling.textContent;
      }

      if (document.querySelector('.button-clear[data-type="van_size"]') && document.querySelector('.search-aside input[name="van_size"]:checked')) {
        document.querySelector('.button-clear[data-type="van_size"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="van_size"]:checked').nextElementSibling.nextElementSibling.textContent;
      }

      document.querySelectorAll('.button-clear').forEach(v => {
        v.addEventListener('click', e => {
          showLoader();
          setUrlParams(e.target.dataset.type, '', document.querySelector('.search-content').dataset.module);
        })
      })

      // unselectRadio('.search-form input[type=radio]');

    }
  } else {
    if (document.querySelector('#search-bar #search-type')) {
      let selectedMake = document.querySelector('#search-bar [name="make"]').options[document.querySelector('#search-bar [name="make"]').selectedIndex].value;
      // Show Models for selected manufacturer
      if (selectedMake) {
        loadModels(document.querySelector('#search-bar #search-type').value, selectedMake.value);
      }
    }

    // if (document.querySelector('.search-aside') && document.querySelector('.derivative-wrapper')) {
    //   let selectedMake = document.querySelector('.search-aside input[name="make"]:checked');
    //   if (searchButton){
    //     document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         selectedMake = document.querySelector('.search-aside input[name="make"]:checked');
    //         document.querySelectorAll('.model-wrapper').forEach(v => { v.innerHTML = ''; v.classList.remove('show'); })
    //         loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);
    //         let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
    //         (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
    //       })
    //     })
    //   }
    //
    //   if (document.querySelector('.search-aside #search-type')) {
    //
    //     // Show Models for selected manufacturer
    //     if (selectedMake) {
    //       loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);
    //
    //       let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
    //       (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
    //       console.log(".3");
    //     }
    //
    //     if(document.querySelector('.search-aside #body_type-wrapper')){
    //       loadBodyTypesRadio(document.querySelector('.search-aside #search-type').value);
    //     }
    //     if(document.querySelector('.search-aside #fuel_type-wrapper')){
    //       loadFuelTypesRadio(document.querySelector('.search-aside #search-type').value);
    //     }
    //     if(document.querySelector('.search-aside #transmission-wrapper')){
    //       loadTransmissionTypesRadio(document.querySelector('.search-aside #search-type').value);
    //     }
    //
    //     (document.querySelector('.button-clear')) ? null : document.querySelector('.clear-filters').classList.add('visuallyhidden');
    //
    //     if(!searchButton) {
    //       document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           showLoader();
    //           document.querySelector('.search-aside .model-wrapper [name="model"]:checked') ? document.querySelector('.search-aside .model-wrapper.show [name="model"]:checked').checked = false : null;
    //           setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside [name="model"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           showLoader();
    //           setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside [name="van_size"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           showLoader();
    //           //remove bodytype
    //           document.querySelector('.search-aside [name="body_type"]:checked') ? document.querySelector('.search-aside [name="body_type"]:checked').checked = false : null;
    //           setUrlParams('van_size', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside [name="body_type"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           showLoader();
    //           //remove van size
    //           document.querySelector('.search-aside [name="van_size"]:checked') ? document.querySelector('.search-aside [name="van_size"]:checked').checked = false : null;
    //           setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
    //           // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
    //         })
    //       })
    //       // document.querySelectorAll('.search-aside input[name="budget"]').forEach(v => {
    //       //   v.addEventListener('change', e => {
    //       //     showLoader();
    //       //     setUrlParams('budget', e.target.value, document.querySelector('.search-content').dataset.module);
    //       //   })
    //       // })
    //       document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           showLoader();
    //           setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
    //           // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           showLoader();
    //           setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside input[name="search_type"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           showLoader();
    //           setUrlParams('type', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       if (document.querySelector('.search-filters select[name="order"]')) {
    //         document.querySelector('.search-filters select[name="order"]').addEventListener('change', e => {
    //           showLoader();
    //           setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       }
    //     }
    //     document.querySelectorAll('.search-filters [name="term"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         showLoader();
    //         setUrlParams('term', e.target.value, document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //     document.querySelectorAll('.search-filters [name="initial_profile"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         showLoader();
    //         setUrlParams('initial_profile', e.target.value, document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //     document.querySelectorAll('.search-filters [name="mileage"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         showLoader();
    //         setUrlParams('mileage', e.target.value, document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //
    //     if (document.querySelector('.button-clear[data-type="make"]') && selectedMake) {
    //       document.querySelector('.button-clear[data-type="make"] > span.text-inner').innerText = selectedMake.nextElementSibling.nextElementSibling.textContent;
    //     }
    //
    //     if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
    //       document.querySelector('.button-clear[data-type="model"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="model"]:checked').nextElementSibling.nextElementSibling.textContent;
    //     }
    //
    //     if (document.querySelector('.button-clear[data-type="van_size"]') && document.querySelector('.search-aside input[name="van_size"]:checked')) {
    //       document.querySelector('.button-clear[data-type="van_size"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="van_size"]:checked').nextElementSibling.nextElementSibling.textContent;
    //     }
    //
    //     document.querySelectorAll('.button-clear').forEach(v => {
    //       v.addEventListener('click', e => {
    //         showLoader();
    //         setUrlParams(e.target.dataset.type, '', document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //
    //     // unselectRadio('.search-form input[type=radio]');
    //
    //   }
    // }
  }
}

function unselectRadio(groupSelector) {
  let currentId;
  document.querySelectorAll(groupSelector).forEach((elem) => {
    elem.addEventListener('click', allowUncheck);
    // needed if elem is already pre-checked
    if (elem.checked) {
      currentId = elem.id;
    }
  });

  function allowUncheck(e) {
    if (this.id === currentId) {
      this.checked = false;
      currentId = undefined;
      if (!searchButton) {
        showLoader();
        setUrlParams(e.target.dataset.type, e.target.value, document.querySelector('.search-content').dataset.module);
      }
    } else {
      currentId = this.id;
    }
  }
}

//END Search Sidebar

// SEARCH
function searchType(elem, searchType) {
  let hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.querySelector('#search-type');
  hiddenField.setAttribute('value', searchType);
  // hiddenField.dispatchEvent(new Event('change'));
  if (searchType == 'used_ev' && document.querySelector('#electric-form')) {
    document.querySelector('#electric-form').action = '/used-evs';
  } else if (searchType != 'used_ev' && document.querySelector('#electric-form')) {
    document.querySelector('#electric-form').action = '/search';
  }

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  let slider = document.querySelector('.vehicle-type .slider');
  slider ? slider.classList.toggle("active") : null;

  if (document.querySelector('.search-aside')) {
    showLoader();
    setUrlParams('type', searchType, document.querySelector('.search-content').dataset.module);
  } else {
    loadManufacturers(hiddenField.value);
    loadBodyTypes(hiddenField.value);
  }

}

function loadManufacturers($type) {
  if (document.querySelector('#search-type').value == 'used_ev') {
    $type = document.querySelector('#search-type').value;
  }
  if ($type) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Make';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    let fuel_type = document.querySelector('input[name="fuel_type"]') ? document.querySelector('input[name="fuel_type"]').value : null;
    document.querySelectorAll('select[name="make"]').forEach((v, i) => {
      v.length = 0;
      v.add(loadingOption);
      v.selectedIndex = 0;
      let url = (fuel_type == 'Electric') ? '/api/'+$type+'/manufacturers/ev?available=yes' : '/api/'+$type+'/manufacturers/available';
      if ($type == 'used_ev') { url = '/api/used-evs/manufacturers'; }
      fetch(url).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        let keysSorted = Object.keys(data).sort(function(a, b) {
          return data[a].localeCompare(data[b])
        });
        v.length = 0;
        v.add(defaultOption);
        v.selectedIndex = 0;
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]].toUpperCase();
          option.value = keysSorted[x];
          (v.hasAttribute('data-img')) ? option.setAttribute('data-img', `/themes/jurni/img/manufacturer/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}.svg`) : null;
          (v.hasAttribute('data-url')) ? option.setAttribute('data-url', `/${$type}-leasing/${data[keysSorted[x]].toLowerCase().replaceAll(' ', '-')}`) : null;
          v.add(option);
        }

        let dataMakeValue = v.getAttribute('data-manufacturer');
        if (dataMakeValue) {
          v.value = dataMakeValue;
          loadModels(document.querySelector('#search-type').value, dataMakeValue);
        }
      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    })
  }
}

function loadManufacturersRadio($type) {
  const wrapper = document.querySelector(`#make-wrapper > .accordion-scroll-inner`);
  if (wrapper && $type) {
    let url = '/api/'+$type+'/manufacturers/available';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '?specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '?stock=true';
      }
    }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let modelWrapper = document.createElement("div");
        modelWrapper.classList.add('model-wrapper');
        modelWrapper.setAttribute('id', `model-wrapper--${value}`);
        modelWrapper.setAttribute('data-make', `${value}`);
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedMake = new URLSearchParams(window.location.search).get('make');
        let selectedType = new URLSearchParams(window.location.search).get('search_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'make');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        ((value == selectedMake) && ($type == selectedType)) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-round');
        wrapper.appendChild(label);
        wrapper.appendChild(modelWrapper);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
      }
      if(!searchButton) {
        document.querySelectorAll('.search-aside input[name="make"]').forEach(v => {
          v.addEventListener('change', e => {
            showLoader();
            setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
      }
      if (document.querySelector('.button-clear[data-type="make"]') && document.querySelector('.search-aside input[name="make"]:checked')) {
        document.querySelector('.button-clear[data-type="make"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="make"]:checked').id.toUpperCase();
      }
      loadSearchTriggers();
    }).catch(function(err) {
      wrapper.innerHTML = 'Please select a manufacturer';
      console.error('Fetch Error -', err);
    });
  }
}

function loadModels($type, $manufacturer, $ev_only = false) {
  if (document.querySelector('#search-type').value == 'used_ev') {
    $type = document.querySelector('#search-type').value;
  }
  
  if ($type && $manufacturer) {
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Model';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';

    var model_dropdowns = document.getElementsByName("model");
    for (let i = 0; i < model_dropdowns.length; i++) {
      var dropdown = model_dropdowns[i];
      dropdown.length = 0;
      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      // Select the option with value equal to data-make
      let dataMake = document.querySelector('.derivative-search-bar select[name="make"]');
      if (dataMake) {
        $manufacturer = dataMake.value;
      }

      if ($manufacturer) {
        dropdown.length = 0;
        dropdown.add(loadingOption);
        dropdown.selectedIndex = 0;

        if(document.querySelector('.derivative-search-bar') && document.querySelector('body').classList.contains('theme-green')){
          $ev_only = true;
        }
        var url = $ev_only ? '/api/'+$type+'/models/'+$manufacturer+'/ev?available' : '/api/'+$type+'/models/'+$manufacturer+'/available';
        if ($type == 'used_ev') { url = '/api/used-evs/models/' + $manufacturer; }

        fetch(url).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          dropdown.length = 0;
          dropdown.add(defaultOption);
          dropdown.selectedIndex = 0;
          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            let option = document.createElement('option');
            option.text = data[keysSorted[x]];
            option.value = keysSorted[x];
            dropdown.add(option);
          }
          const urlParams = new URLSearchParams(window.location.search);
          const makeParam = urlParams.get('make');
          const modelParam = urlParams.get('model');
          if (modelParam && makeParam == $manufacturer) {
            dropdown.value = modelParam;
          }

          let dataModelValue = dropdown.getAttribute('data-model');
          if (dataModelValue && dataMake) {
            if(dataMake.getAttribute('data-manufacturer') == dataMake.value){
              dropdown.value = dataModelValue;
            } else {
              dropdown.selectedIndex = 0;
            }
          }
        }).catch(function(err) {
          dropdown.length = 0;
          dropdown.add(loadingError);
          dropdown.selectedIndex = 0;
          console.error('Fetch Error -', err);
        });
      }
    }
  }
}

function loadModelsRadio($type, $manufacturer) {
  const wrapper = document.querySelector(`#model-wrapper--${$manufacturer}`);
  if (wrapper && $type && $manufacturer) {

    let url = '/api/'+$type+'/models/'+$manufacturer+'/available';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '?specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '?stock=true';
      }
    }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedModel = new URLSearchParams(window.location.search).get('model');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'model');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedModel) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-round');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
      }
      if(!searchButton) {
        document.querySelectorAll('.search-aside input[name="model"]').forEach(v => {
          v.addEventListener('change', e => {
            showLoader();
            setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
      }
      if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
        document.querySelector('.button-clear[data-type="model"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="model"]:checked').id.toUpperCase();
      }
    }).catch(function(err) {
      wrapper.innerHTML = 'Please select a manufacturer';
      console.error('Fetch Error -', err);
    });
  }
}

function loadBodyTypes($type) {
  let dropdown = document.querySelector('[name=body_type]');
  if (dropdown && $type) {
    if ($type == 'used_ev') { $type = 'car'; }
    let defaultOption = document.createElement('option');
    defaultOption.text = 'Any Bodytype';
    defaultOption.value = '';
    let loadingOption = document.createElement('option');
    loadingOption.text = 'Loading...';
    loadingOption.value = '';
    let loadingError = document.createElement('option');
    loadingError.text = 'Loading Error, please check your internet connection';
    loadingError.value = '';
    dropdown.length = 0;

    dropdown.length = 0;
    dropdown.add(loadingOption);
    dropdown.selectedIndex = 0;

    let url = '/api/' + $type + '/types?available';
    url += document.querySelector('.search-form [name="make"]').value != '' ? '&make=' + document.querySelector('.search-form [name="make"]').value : '';
    if (document.querySelector('.search-form [name="model"]')) {
      url += document.querySelector('.search-form [name="model"]').value!='' ? '&model='+document.querySelector('.search-form [name="model"]').value : '';
    }

    if (document.querySelector('form.search-form')) {
      if (window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')) {
        url += '&specials=true';
      }
      if (window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')) {
        url += '&stock=true';
      }
    }


    fetch(url).then(function (response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function (data) {

      dropdown.length = 0;

      var defaultOption = document.createElement('option');
      defaultOption.text = 'Any Bodytype';
      defaultOption.value = '';

      dropdown.add(defaultOption);
      dropdown.selectedIndex = 0;

      let keysSorted = Object.keys(data).sort(function (a, b) {
        return data[a].localeCompare(data[b])
      });

      const urlParams = new URLSearchParams(window.location.search);
      const body_type = urlParams.get('body_type');

      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        dropdown.add(option);
      }
      if (body_type) {
        dropdown.value = body_type;
      }
    }).catch(function (err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadBodyTypesRadio($type) {
  const wrapper = document.querySelector('#body_type-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/types?available';
    url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
    url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
    }

    // console.log('loadBodyTypesCheckbox')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedBodyType = new URLSearchParams(window.location.search).get('body_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'body_type');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedBodyType) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-round');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
        spanName.innerText = text.replaceAll('4x4', '4x4/SUV');
        spanName.innerText = text.replaceAll('Sports', 'Convertible');
      }

      if (!searchButton) {
        if (document.querySelectorAll('.search-aside input[name="body_type"]')) {
          document.querySelectorAll('.search-aside input[name="body_type"]').forEach(v => {
            v.addEventListener('change', e => {
              showLoader();
              setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
              // setUrlParams('body_type', ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
            })
          })
        }
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadFuelTypesRadio($type) {
  const wrapper = document.querySelector('#fuel_type-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/fuel-types?available';
    url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
    url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';
    if (document.querySelector('#body_type-wrapper')) {
      url += document.querySelector('.search-form input[name="body_type"]:checked')!=null ? '&body_type='+document.querySelector('.search-form input[name="body_type"]:checked').value : '';
    } else {
      url += document.querySelector('.search-form [name="body_type"]').value!='' ? '&body_type='+document.querySelector('.search-form [name="body_type"]').value : '';
    }

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
      (window.location.pathname === '/electric-leasing' || window.location.pathname === '/van-leasing/electric' || window.location.pathname === '/hybrid-leasing' || window.location.pathname === '/van-leasing/hybrid') ? wrapper.parentElement.classList.add('visuallyhidden') : wrapper.parentElement.classList.remove('visuallyhidden')
    }

    // console.log('loadFuelTypesRadio')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      delete data['B'];
      delete data['R'];
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      keysSorted.unshift('Any');
      for (let x in keysSorted) {
        let text = (keysSorted[x]=='Any') ? keysSorted[x] : data[keysSorted[x]].replace(" ","-");
        let value = (keysSorted[x]=='Any') ? '' : keysSorted[x].replace(" ","-");
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedFuelType = new URLSearchParams(window.location.search).get('fuel_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text);
        input.setAttribute('name', 'fuel_type');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (selectedFuelType == value) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text);
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-round');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = (keysSorted[x]=='Any') ? 'Any' : text.replace("-"," ");
      }

      if (!searchButton) {
        if(document.querySelectorAll('.search-aside input[name="fuel_type"]')){
          document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
            v.addEventListener('change', e => {
              showLoader();
              setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
              // setUrlParams('fuel_type', ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
            })
          })
        }
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadTransmissionTypesRadio($type) {
  const wrapper = document.querySelector('#transmission-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/transmissions?available';
    url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
    url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';
    if (document.querySelector('#body_type-wrapper')) {
      url += document.querySelector('.search-form input[name="body_type"]:checked')!=null ? '&body_type='+document.querySelector('.search-form input[name="body_type"]:checked').value : '';
    } else {
      url += document.querySelector('.search-form [name="body_type"]').value!='' ? '&body_type='+document.querySelector('.search-form [name="body_type"]').value : '';
    }

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
    }

    // console.log('loadTransmissionTypesRadio')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      // keysSorted.unshift('Any');
      for (let x in keysSorted) {
        let text = (keysSorted[x]=='Any') ? keysSorted[x] : data[keysSorted[x]];
        let value = keysSorted[x];
        value = (value === 'Automatic') ? 'A' : (value === 'Manual') ? 'M' : (value === 'Any') ? '' : value;
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedTransmissionType = new URLSearchParams(window.location.search).get('transmission');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text);
        input.setAttribute('name', 'transmission');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedTransmissionType) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text);
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-round');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
      }

      if (!searchButton) {
        if(document.querySelectorAll('.search-aside input[name="transmission"]')){
          document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
            v.addEventListener('change', e => {
              showLoader();
              setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
            })
          })
        }
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

// Search Budget slider
function loadBudgetSlider() {
  const budgetSlider = document.querySelector('#budget-slider');
  const updateResultsBtn = document.getElementById('update-results-btn');
  const budgetHiddenField = document.querySelector('input[name="budget"]');
  if(budgetSlider && updateResultsBtn){
    let initial_min = parseInt(budgetSlider.dataset.min);
    let initial_max = parseInt(budgetSlider.dataset.max);
    let updateSliderValue;

    if (budgetSlider.querySelector('.noUi-base')) {
      budgetSlider.classList = 'sliderContainer';
      budgetSlider.querySelector('.noUi-base').remove();
      delete budgetSlider.noUiSlider;
    }

    noUiSlider.create(budgetSlider, {
      start: [initial_min, initial_max],
      step: 100,
      margin: 100,
      behaviour: 'drag',
      connect: true,
      range: {
        min: 0,
        max: 1000
      },
      format: {
        to: function(value) {
          if (value === 1000) {
            return 'No Max';
          }
          return value;
        },
        from: function(value) {
          if (value === 'No Max') {
            return 1000;
          }
          return value;
        }
      }
    });
    updateSliderValue = function(slider, handle = 0) {
      let children, i, results, val, values;
      children = slider.getElementsByClassName('noUi-handle');
      values = slider.noUiSlider.get();
      i = 0;
      results = [];
      while (i < children.length) {
        if (children.length === 1) {
          val = parseInt(values);
        } else {
          val = parseInt(values[i]);
        }
        if(val == 1000){
          val = 'No Max';
        }
        children[i].dataset.value = val;
        results.push(i++);
      }
      return results;
    };
    budgetSlider.noUiSlider.on('update', function() {
      const selectedValues = budgetSlider.noUiSlider.get();
      let updated_min = parseInt(selectedValues[0]);
      let updated_max = parseInt(selectedValues[1]);

      if(isNaN(updated_max)){
        updated_max = 1000;
      }

      if (updated_max == 1000) {
        budgetHiddenField ? budgetHiddenField.value = `${updated_min}+` : null;
      } else {
        budgetHiddenField ? budgetHiddenField.value = `${updated_min}-${updated_max}` : null;
      }

      if (!searchButton) {
        if(document.querySelector('.mobile-accordion[data-field="budget"]').classList.contains('active')){
          if (initial_min != updated_min || initial_max != updated_max) {
            updateResultsBtn.classList.add('slider-moved')
          } else {
            updateResultsBtn.classList.remove('slider-moved')
          }
        }
      }

      if(updated_max - updated_min < 200 && updated_max - updated_min > 0){
        document.querySelector('#budget-slider .noUi-handle-lower').classList.add('min-handle');
        document.querySelector('#budget-slider .noUi-handle-upper').classList.add('max-handle');
      } else{
        document.querySelector('#budget-slider .noUi-handle-lower').classList.remove('min-handle');
        document.querySelector('#budget-slider .noUi-handle-upper').classList.remove('max-handle');
      }

      if(updated_max == 1000){
        document.querySelector('#budget-slider .noUi-handle-upper').classList.add('no-max');
      } else{
        document.querySelector('#budget-slider .noUi-handle-upper').classList.remove('no-max');
      }

      return updateSliderValue(budgetSlider);
    });

    updateResultsBtn.addEventListener('click', function(e){
      e.preventDefault();

      // Get the selected values from the slider
      const selectedValues = budgetSlider.noUiSlider.get();
      let minValue = parseInt(selectedValues[0]);
      let maxValue = parseInt(selectedValues[1]);

      showLoader();
      if(isNaN(maxValue)){
        setUrlParams('budget', minValue + '+', document.querySelector('.search-content').dataset.module);
      } else{
        setUrlParams('budget', minValue + '-' + maxValue, document.querySelector('.search-content').dataset.module);
      }
    });

  }
}
// END SEARCH

document.addEventListener("DOMContentLoaded", function() {

  // Pagination
  document.querySelectorAll('.pagination-holder .results-per-page select option')?.forEach(v => { (v.innerHTML = v.innerHTML.replace('Show', '<span>Results Per Page:</span>')) })
  document.querySelector('.pagination-holder .results-per-page select option[value="All"]')?.setAttribute('value', '9999')
  let url = new URL(document.URL);
  url.searchParams.has('show') ? (url.searchParams.get('show') === '9999' ? document.querySelector('.pagination-holder .results-per-page select').selectedIndex = 6 : null) : null;

  document.querySelector('.pagination-holder .results-per-page select')?.addEventListener('change', ev => {
    url.searchParams.set('show', (ev.target.value === 'All') ? '9999' : ev.target.value);
    url.searchParams.has('page') ? url.searchParams.delete('page') : null;
    window.location.href = url;
  })
  // END Pagination

  // Feefo Reviews
  // const xhttp = new XMLHttpRequest();
  // xhttp.onload = function() {
  //   let reviewsTop = document.querySelector('#feefo_top');
  //   if(this.response && reviewsTop){
  //     reviewsTop.querySelector('#reviews_text > tspan:first-child').innerHTML = `${JSON.parse(this.response).rating.rating}`;
  //     reviewsTop.querySelector('#reviews_text > tspan:last-child').innerHTML = `${JSON.parse(this.response).meta.count} Reviews`;
  //     reviewsTop.parentElement.setAttribute('href', JSON.parse(this.response).merchant.review_url)
  //     reviewsTop.classList.remove('visuallyhidden');
  //   } else {
  //     reviewsTop ? reviewsTop.classList.add('visuallyhidden') : null;
  //   }
  //
  //   let reviewsHero = document.querySelector('#feefo_hero');
  //   if(this.response && reviewsHero) {
  //     reviewsHero.querySelector('#reviews_text > tspan:first-child').innerHTML = `${JSON.parse(this.response).rating.rating}`;
  //     reviewsHero.parentElement.setAttribute('href', JSON.parse(this.response).merchant.review_url)
  //     reviewsHero.classList.remove('visuallyhidden');
  //   } else {
  //     reviewsHero ? reviewsHero.classList.add('visuallyhidden') : null;
  //   }
  //
  // }
  // xhttp.open("GET", "https://api.feefo.com/api/20/reviews/summary/all?merchant_identifier=planet-leasing");
  // xhttp.send();
  // END Feefo Reviews

  // Search Sidebar
  // let filterSwitch = document.querySelectorAll('.filter-switch');
  // if(filterSwitch){
  //   Array.prototype.slice.call(filterSwitch, 0).forEach((value) => {
  //     value.addEventListener('click', () => {
  //       document.querySelector('#page').classList.toggle('open');
  //       document.querySelector('.search-results-filters').classList.toggle('open');
  //       // document.querySelector('.search-results-filters-switch').classList.toggle('open');
  //     })
  //   })
  // }
  // let breadcrumbsSwitch = document.querySelector('.breadcrumbs-search.filter-switch');
  // if (breadcrumbsSwitch){
  //   document.querySelector('#page').classList.add('has-search');
  // }
  // let searchPage = document.querySelector('.breadcrumbs.search-page');
  // if (searchPage){
  //   document.querySelector('#page').classList.add('search-page');
  // }
  // END Search Sidebar

  // Latest Offers - Show More
  // document.querySelectorAll('.offers-strip-more').forEach(value => {
  //   value.addEventListener('click', (e) => {
  //     e.target.closest('.offers-strip').classList.toggle('show-more');
  //   })
  // })

  //Search Filters Toggle
  let filterTerms = document.querySelector('#filter-terms');
  let searchFilters = document.querySelector('.search-filters');
  if (filterTerms && searchFilters){
    filterTerms.addEventListener('click', (e) => {
      if (filterTerms.classList.contains('active')){
        searchFilters.classList.add('active');
      } else {
        searchFilters.classList.remove('active');
      }
    })
  }


  // document.querySelectorAll('.offers-strip-more').forEach(value => {
  //   value.addEventListener('click', (e) => {
  //     let element = e.target.closest('.offers-strip');
  //     let showMore = element.querySelector('span.show-more-btn');
  //
  //     element.classList.toggle('show-more');
  //     if(element.classList.contains('show-more')){
  //       showMore.innerHTML = 'Show less';
  //     } else {
  //       showMore.innerHTML = 'Show more';
  //     }
  //   })
  // })

  // var classname = document.querySelectorAll(".offers-strip-more");
  //
  // var showMore = function(e) {
  //   e.preventDefault();
  //   let element = classname.closest('.offers-strip');
  //   element.classList.toggle("active");
  //   if(element.classList.contains('active')){
  //     this.innerHTML = 'Hide additional options';
  //   } else {
  //     this.innerHTML = 'Show me more options';
  //   }
  // };
  //
  // for (var i = 0; i < classname.length; i++) {
  //   classname[i].addEventListener('click', showMore, false);
  // }

  // Model Table Search
  if (document.querySelector('#model-table')) {
    let filterFields = document.querySelectorAll('.model-table-head input');
    const filterTable = (field, value) => {
      let searchType = field;

      if (value !== '' && value.length > 0) {
        let elements = document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']');

        elements.forEach((v) => {
          v.classList.add('hidden-' + field + '')
          if(v.getAttribute('data-' + searchType + '').includes(value)) {
            v.classList.remove('hidden-' + field + '')
          }
        })
      } else {
        document.querySelectorAll('.model-table-wrapper[data-' + searchType + ']').forEach((v) => {
          v.classList.remove('hidden-' + field + '')
        });
      }

      // Show no results text
      if(!document.querySelectorAll('.model-table-wrapper:not([class*="hidden"]):not(.no-results)').length > 0) {
        document.querySelector('.no-results').classList.remove('hidden-no-results', 'hidden');
      } else {
        document.querySelector('.no-results').classList.add('hidden-no-results');
      }
    }
    if (filterFields) {
      filterFields.forEach((value => {
        value.addEventListener('change', (event) => {
          let val = value.value;
          let field = value.getAttribute('name');
          filterTable(field, val);
        })
      }))
    }
    // let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
    // allSwitches.forEach((value) => {
    //   value.addEventListener('change', (val) => {
    //     filterTable('personal', '');
    //     filterTable('business', '');
    //     document.querySelector('#filterBudget').selectedIndex = 0;
    //     document.querySelector('#filterBudgetBusiness').selectedIndex = 0;
    //   })
    // })
  }
  // End Model Table Search

  // Add To Compare - Car
  document.querySelectorAll('button[data-compare][data-type="car"]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('compare_list')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.compare] === undefined) {
          if (Object.keys(cookie_obj).length < 3) {
            cookie_obj = {...cookie_obj, [e.target.dataset.compare] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list', cookie_string)
            e.target.classList.add('active');
            e.target.dataset.compareAdded = 'true';
            alertify.confirm('Car Comparison')
              .setting({
                'title': 'Car Comparison',
                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to comparison
                  ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                    <br><br> <span class="semi-bold">You are comparing:</span>
                    <ul>
                      <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/jurni/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                      ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/jurni/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                      ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/jurni/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                    </ul>
                  ` : ''}
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/tools-calculators/car-comparison" },
                'onclose': comparisonCount
              });
          } else {
            alertify.confirm('Car Comparison')
              .setting({
                'title': 'Car Comparison',
                'message': `
                  <span class="semi-bold">Car comparison full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items below and add ${e.target.dataset.name} again.</span>
                  <br><br> <span class="semi-bold">You are comparing:</span>
                  <ul>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/jurni/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/jurni/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/jurni/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                  </ul>
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/tools-calculators/car-comparison" },
                'onclose': comparisonCount
              });
          }
        } else {
          delete cookie_obj[e.target.dataset.compare];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
          e.target.classList.remove('active');
          e.target.dataset.compareAdded = 'false';
          alertify.confirm('Car Comparison')
            .setting({
              'title': 'Car Comparison',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from comparison`,
              'labels': { ok: 'Go To Compare', cancel: 'Close' },
              'onok': function(){ window.location.href = "/tools-calculators/car-comparison" },
              'onclose': comparisonCount
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.compare}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('compare_list', cookie_string)
        e.target.classList.add('active');
        e.target.dataset.compareAdded = 'true';

        alertify.confirm('Car Comparison')
          .setting({
            'title': 'Car Comparison',
            'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to comparison`,
            'labels': { ok: 'Go To Compare', cancel: 'Close' },
            'onok': function(){ window.location.href = "/tools-calculators/car-comparison" },
            'onclose': comparisonCount
          });
      }
    })
  })
  // Add To Compare - Van
  document.querySelectorAll('button[data-compare][data-type="van"]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('compare_list_vans')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.compare] === undefined) {
          if (Object.keys(cookie_obj).length < 3) {
            cookie_obj = {...cookie_obj, [e.target.dataset.compare] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list_vans', cookie_string)
            e.target.classList.add('active');
            e.target.dataset.compareAdded = 'true';
            alertify.confirm('Van Comparison')
              .setting({
                'title': 'Van Comparison',
                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to comparison
                  ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                    <br><br> <span class="semi-bold">You are comparing:</span>
                    <ul>
                      <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/jurni/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                      ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/jurni/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                      ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/jurni/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                    </ul>
                  ` : ''}
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/tools-calculators/van-comparison" },
                'onclose': comparisonCount
              });
          } else {
            alertify.confirm('Car Comparison')
              .setting({
                'title': 'Van Comparison',
                'message': `
                  <span class="semi-bold">Van comparison full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items below and add ${e.target.dataset.name} again.</span>
                  <br><br> <span class="semi-bold">You are comparing:</span>
                  <ul>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/jurni/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/jurni/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2211\\x22 height=\\x2211\\x22><use xlink:href=\\x22/themes/jurni/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                  </ul>
                `,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/tools-calculators/van-comparison" },
                'onclose': comparisonCount
              });
          }
        } else {
          delete cookie_obj[e.target.dataset.compare];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans');
          e.target.classList.remove('active');
          e.target.dataset.compareAdded = 'false';
          alertify.confirm('Van Comparison')
            .setting({
              'title': 'Van Comparison',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from comparison`,
              'labels': { ok: 'Go To Compare', cancel: 'Close' },
              'onok': function(){ window.location.href = "/tools-calculators/van-comparison" },
              'onclose': comparisonCount
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.compare}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('compare_list_vans', cookie_string)
        e.target.classList.add('active');
        e.target.dataset.compareAdded = 'true';

        alertify.confirm('Van Comparison')
          .setting({
            'title': 'Van Comparison',
            'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to comparison`,
            'labels': { ok: 'Go To Compare', cancel: 'Close' },
            'onok': function(){ window.location.href = "/tools-calculators/van-comparison" },
            'onclose': comparisonCount
          });
      }
    })
  })
  // Add To Favourites - Car
  document.querySelectorAll('button[data-favourite][data-type="car"]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('favourite_list')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.favourite] === undefined) {
          if (Object.keys(cookie_obj).length < 30) {
            cookie_obj = {...cookie_obj, [e.target.dataset.favourite] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('favourite_list', cookie_string)
            e.target.classList.add('active');
            e.target.dataset.favouriteAdded = 'true';
            alertify.confirm('Your Favourites')
              .setting({
                'title': 'Your Favourites',
                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to favourites
                `,
                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                'onok': function(){ window.location.href = "/saved" }
              });
          } else {
            alertify.confirm('Your Favourites')
              .setting({
                'title': 'Your Favourites',
                'message': `
                  <span class="semi-bold">Favourites list full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items on your favourites list add ${e.target.dataset.name} again.</span>
                `,
                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                'onok': function(){ window.location.href = "/saved" }
              });
          }
        } else {
          delete cookie_obj[e.target.dataset.favourite];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('favourite_list', JSON.stringify(cookie_obj)) : Cookies.remove('favourite_list');
          e.target.classList.remove('active');
          e.target.dataset.favouriteAdded = 'false';
          document.querySelector('.tools-main>.favourites') ? e.target.closest('.deal-box').remove() : null;
          alertify.confirm('Your Favourites')
            .setting({
              'title': 'Your Favourites',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from favourites`,
              'labels': { ok: 'Go To Favourites', cancel: 'Close' },
              'onok': function(){ window.location.href = "/saved" }
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.favourite}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('favourite_list', cookie_string)
        e.target.classList.add('active');
        e.target.dataset.favouriteAdded = 'true';
        alertify.confirm('Your Favourites')
          .setting({
            'title': 'Your Favourites',
            'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to favourites`,
            'labels': { ok: 'Go To Favourites', cancel: 'Close' },
            'onok': function(){ window.location.href = "/saved" }
          });
      }
    })
  })
  // Add To Favourites - Van
  document.querySelectorAll('button[data-favourite][data-type="van"]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('favourite_list_vans')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.favourite] === undefined) {
          if (Object.keys(cookie_obj).length < 30) {
            cookie_obj = {...cookie_obj, [e.target.dataset.favourite] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('favourite_list_vans', cookie_string)
            e.target.classList.add('active');
            e.target.dataset.favouriteAdded = 'true';
            alertify.confirm('Your Favourites')
              .setting({
                'title': 'Your Favourites',
                'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to favourites
                `,
                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                'onok': function(){ window.location.href = "/saved" }
              });
          } else {
            alertify.confirm('Your Favourites')
              .setting({
                'title': 'Your Favourites',
                'message': `
                  <span class="semi-bold">Favourites list full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items on your favourites list add ${e.target.dataset.name} again.</span>
                `,
                'labels': { ok: 'Go To Favourites', cancel: 'Close' },
                'onok': function(){ window.location.href = "/saved" }
              });
          }
        } else {
          delete cookie_obj[e.target.dataset.favourite];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('favourite_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('favourite_list_vans');
          e.target.classList.remove('active');
          e.target.dataset.favouriteAdded = 'false';
          document.querySelector('.tools-main>.favourites') ? e.target.closest('.deal-box').remove() : null;
          alertify.confirm('Your Favourites')
            .setting({
              'title': 'Your Favourites',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from favourites`,
              'labels': { ok: 'Go To Favourites', cancel: 'Close' },
              'onok': function(){ window.location.href = "/saved" }
            });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.favourite}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('favourite_list_vans', cookie_string)
        e.target.classList.add('active');
        e.target.dataset.favouriteAdded = 'true';
        alertify.confirm('Your Favourites')
          .setting({
            'title': 'Your Favourites',
            'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to favourites`,
            'labels': { ok: 'Go To Favourites', cancel: 'Close' },
            'onok': function(){ window.location.href = "/saved" }
          });
      }
    })
  })
  // Compare Count
  function comparisonCount() {
    let car_count = 0;
    let cookie = Cookies.get('compare_list')
    if (Cookies.get('compare_list')) {
      let cookie_obj = JSON.parse(cookie);
      car_count = Object.keys(cookie_obj).length;
    }
    document.querySelectorAll('.comparison_counter').forEach(v => { v.innerText = car_count });
    let van_count = 0;
    let van_cookie = Cookies.get('compare_list_vans')
    if (Cookies.get('compare_list_vans')) {
      let van_cookie_obj = JSON.parse(van_cookie);
      van_count = Object.keys(van_cookie_obj).length;
    }
    document.querySelectorAll('.comparison_counter_van').forEach(v => { v.innerText = van_count });
  }
  comparisonCount();
  document.querySelectorAll('div[data-car] .reset, .alertify .reset, button[data-compare]').forEach(value => {
    value.addEventListener('click', evt => {
      comparisonCount();
    })
  })
  let derivativeField = document.querySelector('#car-comparison select[name=calculator-derivative]');
  if (derivativeField) {
    derivativeField.addEventListener('change', (event) => {
      comparisonCount();
    })
  }
  document.querySelectorAll('div[data-car] .reset, button[data-compare]').forEach(value => {
    value.addEventListener('click', evt => {
      comparisonCount();
    })
  })

  // Share Button
  document.querySelectorAll('button.share-button').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      alertify.alert('Share')
        .setting({
          'title': `Share ${e.target.dataset.car}`,
          'message': `
                <p class="share-button">
                  <a class="share-facebook" href="https://www.facebook.com/sharer/sharer.php?u=${e.target.dataset.url}" title="Share by Facebook" target="_blank">
                      <svg id="_01.facebook" data-name="01.facebook" xmlns="http://www.w3.org/2000/svg" width="29.577" height="29.577" viewBox="0 0 29.577 29.577">
                        <ellipse id="Ellipse_4401" data-name="Ellipse 4401" cx="14" cy="13.5" rx="14" ry="13.5" transform="translate(0.524 1.451)" fill="#fff"/>
                        <path id="Path_608" data-name="Path 608" d="M14.789,0A14.789,14.789,0,1,0,29.577,14.789,14.789,14.789,0,0,0,14.789,0Zm3.748,13.388-.245,2.061a.389.389,0,0,1-.389.346h-2.14V21.9a.276.276,0,0,1-.272.278H13.31a.276.276,0,0,1-.272-.28l.012-6.108H11.428a.389.389,0,0,1-.389-.389V13.347a.389.389,0,0,1,.389-.389h1.609v-2a3.213,3.213,0,0,1,3.386-3.567h1.648a.389.389,0,0,1,.389.389V9.517a.389.389,0,0,1-.389.389h-1.01c-1.094.018-1.3.541-1.3,1.323v1.722h2.4a.389.389,0,0,1,.378.436Z" fill="#405a9a"/>
                      </svg>
                      &nbsp;Share by Facebook
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-twitter" href="https://twitter.com/intent/tweet?text=${e.target.dataset.url}" title="Share by Twitter" target="_blank">
                      <svg id="Group_1789" data-name="Group 1789" xmlns="http://www.w3.org/2000/svg" width="29.535" height="29.535" viewBox="0 0 29.535 29.535">
                        <circle id="Ellipse_4400" data-name="Ellipse 4400" cx="13.5" cy="13.5" r="13.5" transform="translate(0.956 1.089)" fill="#fff"/>
                        <path id="Path_609" data-name="Path 609" d="M14.767,0A14.767,14.767,0,1,0,29.535,14.767,14.767,14.767,0,0,0,14.767,0Zm7.355,10.3a6.235,6.235,0,0,1-1.265,1.389.54.54,0,0,0-.194.422v.049a8.856,8.856,0,0,1-.571,3.082,9.026,9.026,0,0,1-1.681,2.817,8.3,8.3,0,0,1-3.643,2.407,9.113,9.113,0,0,1-2.864.445,8.743,8.743,0,0,1-4.39-1.183.253.253,0,0,1-.121-.28.243.243,0,0,1,.237-.183H8a5.889,5.889,0,0,0,3.292-1,3.2,3.2,0,0,1-2.526-2.17.167.167,0,0,1,.194-.216,2.93,2.93,0,0,0,.536.051h.068A3.191,3.191,0,0,1,7.7,12.993a.167.167,0,0,1,.247-.146,2.806,2.806,0,0,0,.727.282,3.191,3.191,0,0,1-.515-3.869.167.167,0,0,1,.274-.021A8.355,8.355,0,0,0,14.169,12.3h.016a.12.12,0,0,0,.117-.13,3.379,3.379,0,0,1,.074-1.166,3.091,3.091,0,0,1,2.079-2.223,3.418,3.418,0,0,1,1.008-.155,3.179,3.179,0,0,1,2.106.795.412.412,0,0,0,.274.1.418.418,0,0,0,.1-.014,5.888,5.888,0,0,0,1.554-.641.165.165,0,0,1,.243.194A3.154,3.154,0,0,1,20.9,10.4a5.709,5.709,0,0,0,1.018-.344.167.167,0,0,1,.2.239Z" fill="#64adf0"/>
                      </svg>
                      &nbsp;Share by Twitter
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-linkedin" href="https://www.linkedin.com/shareArticle?mini=true&url=${e.target.dataset.url}" title="Share by LinkedIn" target="_blank">
                      <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
                          <g id="Layer_1-2"><path d="m542.45,1075.59C248.67,1076.4,5.67,837.06,7,537.78,8.31,242,250.29,1.17,549.67,5.11c293.69,3.86,530.16,244.44,527.95,539.4-2.21,294.77-242.66,531.68-535.17,531.08Zm54.06-279.84v-6.2c0-66.8,0-133.6,0-200.41,0-3,.05-6,.11-8.99.42-21.18,9.69-38.17,25.37-51.72,15.66-13.53,34.22-17.08,54.27-13.95,18.91,2.95,32.2,13.53,40.36,30.67,1.64,3.44,2.99,7.05,4.18,10.68,4.25,12.96,5.56,26.38,5.58,39.9.09,64.8.04,129.61.05,194.41,0,1.92.09,3.84.13,5.58h123.27c0-2.31,0-4.28,0-6.25,0-66.3.06-132.61-.05-198.91-.02-11.48-.35-22.99-1.21-34.43-1.56-20.7-6.03-40.83-14.23-59.97-15.77-36.82-42.18-62.19-80.89-73.85-20.33-6.12-41.16-7.67-62.28-5.54-20.74,2.09-40,8.3-57.29,20.16-13.51,9.27-24.32,21.16-33.63,34.53-.96,1.38-1.6,3.12-3.74,4.19v-17.46c0-5.5.01-10.99,0-16.49-.02-5.59-.06-11.18-.09-16.69-12.71-1.03-119.67-.55-123.31.49,1.36,123.36.08,246.72-.25,370.25h123.65Zm-315.51-370.77c0,122.7,0,244.9,0,367.09,0,.99.12,1.98.21,2.96.01.15.16.29.27.41.1.12.24.21.71.62,38.76,0,77.87,0,116.99-.01,1.49,0,2.98-.15,4.46-.24.15,0,.31-.1.43-.21.12-.11.19-.27.36-.53v-370.1h-123.45Zm62.76-179.65c-5.29.54-10.63.75-15.85,1.68-35.41,6.29-54.7,33.52-54.14,64.01.48,26.14,15.67,48.46,40.02,57.9,13.05,5.06,26.54,5.85,40.28,4.35,7.31-.8,14.38-2.68,21.13-5.61,27.68-11.99,42.46-41.06,36.07-70.92-4.61-21.57-16.92-36.9-37.26-45.53-9.62-4.08-19.78-5.67-30.25-5.89Z" fill="#005983"/></g>
                      </svg>
                      &nbsp;Share by LinkedIn
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-whatsapp" href="whatsapp://send?text=I'd like to share a link with you: ${e.target.dataset.url}" data-action="share/whatsapp/share" title="Share by WhatsApp" target="_blank">
                        <svg id="_08.whatsapp" data-name="08.whatsapp" xmlns="http://www.w3.org/2000/svg" width="29.646" height="29.646" viewBox="0 0 29.646 29.646">
                          <ellipse id="Ellipse_4398" data-name="Ellipse 4398" cx="14" cy="13.5" rx="14" ry="13.5" transform="translate(1.293 1.52)" fill="#fff"/>
                          <path id="Path_611" data-name="Path 611" d="M56.371,47.966l-.029-.029a5.756,5.756,0,0,0-9.2,6.676l.254.5-.474,2.3v.029L49.2,56.9l.519.257a5.75,5.75,0,0,0,6.651-9.19Zm-.23,6.436a2.4,2.4,0,0,1-1.274,1.11c-.975.236-2.459,0-4.318-1.718l-.023-.021c-1.617-1.51-2.046-2.768-1.95-3.764A2.387,2.387,0,0,1,49.5,48.6a.529.529,0,0,1,.829.2l.6,1.365a.527.527,0,0,1-.064.538l-.3.39a.517.517,0,0,0-.041.575A5.656,5.656,0,0,0,51.547,52.8a5.967,5.967,0,0,0,1.424,1.02.515.515,0,0,0,.564-.119l.349-.353a.53.53,0,0,1,.536-.164l1.424.41a.532.532,0,0,1,.3.8Z" transform="translate(-37.452 -37.239)" fill="#4cd360"/>
                          <path id="Path_612" data-name="Path 612" d="M14.823,0A14.823,14.823,0,1,0,29.646,14.823,14.823,14.823,0,0,0,14.823,0ZM22.17,15a7.355,7.355,0,0,1-10.622,6.348l-3.706.882a.287.287,0,0,1-.3-.117.281.281,0,0,1-.045-.22l.78-3.788a7.353,7.353,0,1,1,13.9-3.1Z" fill="#4cd360"/>
                        </svg>
                      &nbsp;Share by WhatsApp
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-mail" href="mailto:?subject=I'd like to share a link with you&amp;body=${e.target.dataset.url}" title="Share by Email" target="_blank">
                      <svg id="_01.email" data-name="01.email" xmlns="http://www.w3.org/2000/svg" width="29.577" height="29.577" viewBox="0 0 29.577 29.577">
                        <path id="Path_608" data-name="Path 608" d="M14.789,0A14.789,14.789,0,1,0,29.577,14.789,14.789,14.789,0,0,0,14.789,0Z" fill="#18235b"/>
                        <g id="email_1_" data-name="email (1)" transform="translate(7.73 9.534)">
                          <g id="Group_6951" data-name="Group 6951" transform="translate(0 2.915)">
                            <g id="Group_6950" data-name="Group 6950">
                              <path id="Path_10117" data-name="Path 10117" d="M7.419,151.224a.8.8,0,0,1-.828,0L0,147.2v5.349a2.071,2.071,0,0,0,2.07,2.07h9.887a2.071,2.071,0,0,0,2.07-2.07V147.2Z" transform="translate(0 -147.2)" fill="#fff"/>
                            </g>
                          </g>
                          <g id="Group_6953" data-name="Group 6953" transform="translate(0.066)">
                            <g id="Group_6952" data-name="Group 6952" transform="translate(0 0)">
                              <path id="Path_10118" data-name="Path 10118" d="M13.938,57.088H4.052a2.058,2.058,0,0,0-2,1.623L9,62.95l6.939-4.239A2.058,2.058,0,0,0,13.938,57.088Z" transform="translate(-2.048 -57.088)" fill="#fff"/>
                            </g>
                          </g>
                        </g>
                      </svg>
                      &nbsp;Share by Email
                  </a>
                </p>`,
          'label': 'Close'
        });
    })
  })

  // Charging Speeds
  if (document.querySelector('#charging-speeds')) {
    function isElementVisible(el) {
      let rect     = el.getBoundingClientRect(),
        vWidth   = window.innerWidth || document.documentElement.clientWidth,
        vHeight  = window.innerHeight || document.documentElement.clientHeight,
        efp      = function (x, y) { return document.elementFromPoint(x, y) };
      if (rect.right < 0 || rect.bottom < 0
        || rect.left > vWidth || rect.top > vHeight)
        return false;
      return (
        el.contains(efp(rect.left,  rect.top))
        ||  el.contains(efp(rect.right, rect.top))
        ||  el.contains(efp(rect.right, rect.bottom))
        ||  el.contains(efp(rect.left,  rect.bottom))
      );
    }
    function scrollAnimTriggerCheck() {
      if (isElementVisible(document.querySelector('#charging-speeds .deal-charging-legend'))) {
        const speedHome = parseInt(document.getElementById('progress_bar_home').getAttribute('data-speed'));
        const speedFast = parseInt(document.getElementById('progress_bar_fast').getAttribute('data-speed'));
        const speedRapid = parseInt(document.getElementById('progress_bar_rapid').getAttribute('data-speed'));
        const speedUltra = parseInt(document.getElementById('progress_bar_ultra').getAttribute('data-speed'));
        const homeWidth = (speedHome / speedHome) * 100;
        document.body.style.setProperty('--position-home', homeWidth);
        const fastWidth = (speedFast / speedHome) * 100;
        document.body.style.setProperty('--position-fast', fastWidth);
        const rapidWidth = (speedRapid / speedHome) * 100;
        document.body.style.setProperty('--position-rapid', rapidWidth);
        const ultraWidth = (speedUltra / speedHome) * 100;
        document.body.style.setProperty('--position-ultra', ultraWidth);

        document.removeEventListener("scroll", scrollAnimTriggerCheck);
      }
    }
    document.addEventListener("scroll", scrollAnimTriggerCheck);
  }
  if (document.querySelector('#charging-speeds1')) {
    function isElementVisible(el) {
      let rect     = el.getBoundingClientRect(),
        vWidth   = window.innerWidth || document.documentElement.clientWidth,
        vHeight  = window.innerHeight || document.documentElement.clientHeight,
        efp      = function (x, y) { return document.elementFromPoint(x, y) };
      if (rect.right < 0 || rect.bottom < 0
        || rect.left > vWidth || rect.top > vHeight)
        return false;
      return (
        el.contains(efp(rect.left,  rect.top))
        ||  el.contains(efp(rect.right, rect.top))
        ||  el.contains(efp(rect.right, rect.bottom))
        ||  el.contains(efp(rect.left,  rect.bottom))
      );
    }
    function scrollAnimTriggerCheck() {
      if (isElementVisible(document.querySelector('#charging-speeds1 .deal-charging-legend'))) {
        const speedHome = parseInt(document.getElementById('progress_bar_home1').getAttribute('data-speed'));
        const speedFast = parseInt(document.getElementById('progress_bar_fast1').getAttribute('data-speed'));
        const speedRapid = parseInt(document.getElementById('progress_bar_rapid1').getAttribute('data-speed'));
        const speedUltra = parseInt(document.getElementById('progress_bar_ultra1').getAttribute('data-speed'));
        const homeWidth = (speedHome / speedHome) * 100;
        document.body.style.setProperty('--position-home', homeWidth);
        const fastWidth = (speedFast / speedHome) * 100;
        document.body.style.setProperty('--position-fast', fastWidth);
        const rapidWidth = (speedRapid / speedHome) * 100;
        document.body.style.setProperty('--position-rapid', rapidWidth);
        const ultraWidth = (speedUltra / speedHome) * 100;
        document.body.style.setProperty('--position-ultra', ultraWidth);

        document.removeEventListener("scroll", scrollAnimTriggerCheck);
      }
    }
    document.addEventListener("scroll", scrollAnimTriggerCheck);
  }
  // END Charging Speeds

// Auto-slide helper function
  function sliderAuto(slider, milliseconds) {
    const slidesCount = slider.track.childElementCount;
    let slideTimeout = null;
    let nextIndex = 1;

    function slide() {
      slideTimeout = setTimeout(
        function () {
          if (nextIndex >= slidesCount ) {
            nextIndex = 0;
          }
          slider.scrollItem(nextIndex++);
        },
        milliseconds
      );
    }

    slider.ele.addEventListener('glider-animated', function() {
      window.clearInterval(slideTimeout);
      slide();
    });

    slide();
  }

  // Derivative Gallery Slider
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 2,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 6,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 6,
          }
        }
      ]
    })
  }

  // Derivative Gallery Mobile Slider
  const dealGallerySliderMobile = document.querySelector('.deal-detail-mobile .deal-gallery-track');
  if (dealGallerySliderMobile) {
    new Glider(dealGallerySliderMobile, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-detail-mobile .deal-gallery-controls .glider-prev',
        next: '.deal-detail-mobile .deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 959,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 6,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 6,
          }
        }
      ]
    })
  }

  let thumbs = document.querySelectorAll('.deal-gallery .gallery-thumb');
  if(thumbs){
    for (let i = 0; i < thumbs.length; i++) {
      thumbs[i].addEventListener("click", function (e) {
        e.preventDefault();
        [].forEach.call(thumbs, function (el) {
          el.classList.remove("is-active");
        });
        this.classList.add('is-active');
        // document.getElementById("main-img").src = this.dataset.img;
        document.querySelectorAll('.deal-gallery-img').forEach((v) => { v.src = this.dataset.img })
        if(i == 0 && document.querySelector(".deal-gallery.has-video .deal-gallery-main")) {
          document.querySelector(".deal-gallery.has-video .deal-gallery-main").classList.add('video-trigger');
        } else if(document.querySelector(".deal-gallery.has-video .deal-gallery-main")) {
          document.querySelector(".deal-gallery.has-video .deal-gallery-main").classList.remove('video-trigger');
        }
      });
    }
  }
  // END Derivative Gallery Slider

  // Nav Slider
  // const navSlider = document.querySelector('#dropdown-navigation-slider > div:not(.glider-arrows)')
  // if (navSlider) {
  //   new Glider(navSlider, {
  //     slidesToScroll: 1,
  //     slidesToShow: 1,
  //     draggable: false,
  //     scrollLock: true,
  //     arrows: {
  //       prev: '#dropdown-navigation-slider .glider-prev',
  //       next: '#dropdown-navigation-slider .glider-next'
  //     }
  //   })
  //   const navSliderArrows = document.querySelectorAll('#dropdown-navigation-slider > div.glider-arrows > .glider-arrow')
  //   if (navSliderArrows) {
  //     navSliderArrows.forEach((value) => {
  //       value.addEventListener('click', (ev) => {
  //         document.querySelectorAll('#dropdown-navigation-slider img').forEach(e => { e.classList.remove('loaded') })
  //         setTimeout(function() {
  //           document.querySelectorAll('#dropdown-navigation-slider img').forEach(e => { e.classList.add('loaded') })
  //         }, 100)
  //       })
  //     })
  //   }
  // }
  // END Nav Slider

  // Derivative Gallery Modal
  // const galleryButton = document.querySelector('#view-gallery-button');
  // const galleryModal = new tingle.modal({
  //   footer: false,
  //   closeMethods: ['overlay', 'button', 'escape'],
  //   closeLabel: "Close",
  //   cssClass: ['gallery-modal'],
  //   onClose: function() {
  //     this.setContent('');
  //   }
  // });
  // galleryButton?.addEventListener("click", function(e){
  //   const galleryWrapper = document.querySelector('.deal-main .deal-gallery-modal');
  //   const galleryWrapperClone = galleryWrapper.cloneNode(true);
  //   if (galleryWrapperClone) {
  //     galleryModal.setContent(galleryWrapperClone);
  //
  //     galleryModal.open();
  //
  //     const modalGallerySlider = document.querySelector('.tingle-modal-box .deal-gallery-modal .deal-gallery-track');
  //     if (modalGallerySlider) {
  //       new Glider(modalGallerySlider, {
  //         slidesToScroll: 1,
  //         slidesToShow: 1,
  //         draggable: true,
  //         scrollLock: true,
  //         arrows: {
  //           prev: `.tingle-modal-box .deal-gallery-modal .deal-gallery-controls .glider-prev`,
  //           next: `.tingle-modal-box .deal-gallery-modal .deal-gallery-controls .glider-next`
  //         }
  //       })
  //     }
  //   }
  // })
  // END Derivative Gallery Modal

  // Deal Box Slider CARS
  const dealBoxSliderCars = [].slice.call(document.querySelectorAll('.latest-offers-strip-cars .latest-offers-strip-ctr'))
  if (dealBoxSliderCars) {
    dealBoxSliderCars.forEach((e) => {
      new Glider(e, {
        slidesToScroll: 1,
        slidesToShow: 1,
        draggable: true,
        dots: '.latest-offers-strip-cars .dots',
        scrollLock: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1281,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 1666,
            settings: {
              slidesToShow: 4,
            }
          }
        ]
      })
    })
  }
  // END Deal Box Slider CARS

  // Deal Box Derivative
  const dealBoxSlider = [].slice.call(document.querySelectorAll('.latest-offers-strip-derivative .latest-offers-strip-ctr'))
  if (dealBoxSlider) {
    dealBoxSlider.forEach((e) => {
      new Glider(e, {
        slidesToScroll: 1,
        slidesToShow: 1,
        draggable: true,
        dots: '.latest-offers-strip-derivative .dots',
        scrollLock: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1281,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 1666,
            settings: {
              slidesToShow: 4,
            }
          }
        ]
      })
    })
  }
  // END Deal Box Derivative CARS

  // Manufacturer Strip Slider
  const manufacturerSlider = document.querySelector('.manufacturer-track');
  if (manufacturerSlider) {
    new Glider(manufacturerSlider, {
      slidesToScroll: 2,
      slidesToShow: 2,
      draggable: true,
      dots: '.manufacturer-strip-popular .dots',
      scrollLock: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 6,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 7,
          }
        }
      ]
    })
  }
  // END Manufacturer Strip Slider

  // Funders Strip Slider
  const fundersSlider = document.querySelector('.partner-logos ul');
  if (fundersSlider) {
    const glider = new Glider(fundersSlider, {
      slidesToScroll: 1,
      slidesToShow: 2,
      draggable: true,
      // dots: '.manufacturer-strip-popular .dots',
      scrollLock: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 8,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 8,
          }
        }
      ]
    })
    sliderAuto(glider, 3000);
  }
  // END Funders Strip Slider

  // Model Lookup Strip Slider
  const modelSlider = document.querySelector('.model-lookup-wrapper');
  if (modelSlider) {
    const glider = new Glider(modelSlider, {
      slidesToScroll: 1,
      slidesToShow: 2,
      draggable: true,
      scrollLock: true,
      gap: 20,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 7,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 8,
          }
        }
      ]
    })
    sliderAuto(glider, 5000);
  }
  // END Model Lookup Strip Slider

  // Partner Reviews Slider
  const reviewsSlider = document.querySelector('.reviews-wrapper');
  if (reviewsSlider) {
    const glider = new Glider(reviewsSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      scrollLock: true,
      rewind: true,
      draggable: true,
      dots: '#dots'
    });
    sliderAuto(glider, 8000);
  }

  
  function updateQueryStringParameter(uri, key, value) {
    let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    let separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }
  // END Color Picker


  // CONTACT FORM VALIDATION
  const masterConstraints = {
    first_name: { presence: { allowEmpty: false }, length: { minimum: 3, message: "must be at least 3 characters" } },
    last_name: { presence: { allowEmpty: false }, length: { minimum: 3, message: "must be at least 3 characters" } },
    company: { presence: { allowEmpty: false }, length: { minimum: 3, message: "must be at least 3 characters" } },
    email_address: { presence: { allowEmpty: false }, email: { message: (val) => validate.format("^<strong>%{em}</strong> is not a valid email", { em: val }) } },
    telephone: { presence: { allowEmpty: false }, numericality: { message: "must only contain numbers" }, format: { pattern: /^(07|7|44|\+44|0[1-3]).*$/, message: (val) => validate.format("^<strong>%{num}</strong> is not a valid telephone number", { num: val }) }, length: { minimum: 10, maximum: 12 } },
    occupation: { presence: { allowEmpty: false }, length: { minimum: 3, message: "must be at least 3 characters" } },
    employees_number: { presence: { allowEmpty: false }, numericality: { message: "must only contain numbers" }, length: { minimum: 1 } },
    car_fleet_size: { presence: { allowEmpty: false }, numericality: { message: "must only contain numbers" }, length: { minimum: 1 } },
    lcv_fleet_size: { presence: { allowEmpty: false }, numericality: { message: "must only contain numbers" }, length: { minimum: 1 } },
    website: { presence: { allowEmpty: false } },
    incorporation_date: { presence: { allowEmpty: false } },
    message: { presence: { allowEmpty: false, message: "is required" }, length: { minimum: 2, message: "must be at least 2 characters" } }
  };

  const addMultipleListeners = (el, types, listener) => {
    types.forEach(type => el.addEventListener(type, listener));
  };

  function initContactFormValidation() {
    const form = document.querySelector('#contact-form');
    if (!form || typeof validate === 'undefined') return;

    const runValidation = (e) => {
      let formData = {};
      let availableConstraints = {};

    form.querySelectorAll('[data-validate]').forEach(input => {
        let key = input.dataset.validate;
        formData[key] = input.value ? (key === 'telephone' ? input.value.replace(/\s/g, '') : input.value) : '';

        // Only apply constraint if field exists in masterConstraints AND is marked required on the element
        if (masterConstraints[key] && input.required) {
            availableConstraints[key] = masterConstraints[key];
        }
    });

      let isValid = validate(formData, availableConstraints);
      let consentChecked = document.querySelector('#contact-form #consent')?.checked;
      let submitBtn = document.querySelector('#send-contact-form');

      // Toggle button state
      if (isValid === undefined && consentChecked) {
        if (submitBtn) submitBtn.disabled = false;
        form.querySelectorAll('[data-validate]').forEach(v => v.classList.remove('invalid'));
        form.querySelectorAll('.validation-error').forEach(v => v.remove());
      } else {
        if (submitBtn) submitBtn.disabled = true;

        // Field-level error rendering on user interaction
        if (e && e.target && e.target.dataset.validate) {
          let field = e.target.dataset.validate;
          let fieldEl = form.querySelector(`[data-validate="${field}"]`);

          form.querySelectorAll(`[data-validate="${field}"] ~ .validation-error`).forEach(v => v.remove());

          if (isValid && isValid[field]) {
            if (e.target.type !== 'checkbox') {
              fieldEl?.classList.add('invalid');
              isValid[field].forEach(v => {
                let error = document.createElement("p");
                error.classList.add('validation-error');
                error.innerHTML = `${v}`;
                fieldEl?.parentElement.appendChild(error);
              });
            }
          } else {
            fieldEl?.classList.remove('invalid');
          }
        }
      }
    };

    // Attach listeners across all data-validate fields
    form.querySelectorAll('[data-validate]').forEach(v => {
      addMultipleListeners(v, ['keyup', 'blur', 'change'], runValidation);
    });

    const consentCheckbox = document.querySelector('#contact-form #consent');
    if (consentCheckbox) {
      consentCheckbox.addEventListener('change', function() {
        if (this.checked) {
          document.querySelector('.v-error-consent')?.classList.add('hidden');
        } else {
          document.querySelector('.v-error-consent')?.classList.remove('hidden');
        }
        runValidation();
      });
    }

    // Run initial check on page load
    runValidation();
  }

  // Initialize validation
  initContactFormValidation();


  // Contact Form
  if(document.getElementById('send-contact-form')){
    // Do captcha and submit form

    let button = document.querySelector('#send-contact-form');

    document.getElementById('send-contact-form').addEventListener("click", function(e) {
      e.preventDefault();

      showLoader();
      button.disabled = true;
      button.innerHTML = 'Sending...';

      grecaptcha.ready(function() {
        grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
          document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

          let url = '/contact';
          let form_type = document.querySelector('#contact-form [name=form-type]').value;
          let email = document.querySelector('#contact-form [name=email]').value;
          let forename = document.querySelector('#contact-form [name=name]').value;
          let surname = document.querySelector('#contact-form [name=surname]').value;
          let company = '';
          if (document.querySelector('#contact-form [name=company]')){
            company = document.querySelector('#contact-form [name=company]').value;
          }
          let telephone = document.querySelector('#contact-form [name=telephone]').value;

          let alternative_mailto = null;
          if (document.querySelector('#contact-form [name=alternative-mailto]')){
            alternative_mailto = document.querySelector('#contact-form [name=alternative-mailto]').value;
          }

          let comments = '';
          if (document.querySelector('#contact-form [name=occupation]')) {
            comments = 'Job Title: ' + document.querySelector('#contact-form [name=occupation]').value +
                      (document.querySelector('#contact-form [name=employees-number]') ? '\n\r Number of Employees: ' +
                      document.querySelector('#contact-form [name=employees-number]').value : '') +
                      (document.querySelector('#contact-form [name=car-fleet-size]') ? '\n\r Car Fleet Size: ' +
                      document.querySelector('#contact-form [name=car-fleet-size]').value : '') +
                      (document.querySelector('#contact-form [name=lcv-fleet-size]') ? '\n\r LCV Fleet Size: ' +
                      document.querySelector('#contact-form [name=lcv-fleet-size]').value : '') +
                      '\n\r Message: ' + document.querySelector('#contact-form [name=comments]').value;
          } else if (document.querySelector('#contact-form [name=website]')) {
            comments = 'Website: ' + document.querySelector('#contact-form [name=website]').value +
                      (document.querySelector('#contact-form [name=incorporation-date]') ? '\n\r Incorporation Date: ' +
                      document.querySelector('#contact-form [name=incorporation-date]').value : '');
          } else if (document.querySelector('#contact-form [name=term]')) {
            comments = 'Term: ' + document.querySelector('#contact-form [name=term]').value +
                (document.querySelector('#contact-form [name=mileage]') ? '\n\r Mileage: ' +
                 document.querySelector('#contact-form [name=mileage]').value : '') +
                (document.querySelector('#contact-form [name=seats]') ? '\n\r Number of Seats: ' +
                    document.querySelector('#contact-form [name=seats]').value : '') +
                (document.querySelector('#contact-form [name=comments]') ? '\n\r Message: ' +
                    document.querySelector('#contact-form [name=comments]').value : '');
          } else if (document.querySelector('#contact-form [name=rental]')) {
            comments = 'Rental Duration: ' + document.querySelector('#contact-form [name=rental]').value + ' days' +
                (document.querySelector('#contact-form [name=comments]') ? '\n\r Message: ' +
                    document.querySelector('#contact-form [name=comments]').value : '');
          } else {
            comments = document.querySelector('#contact-form [name=comments]').value;
          }


          let crm_alt = document.querySelector('#contact-form [name=crm_alt]')!==null?'true':'false';

          let csrf_token = document.querySelector('#contact-form [name=_token]').value;

          let marketing_checkboxes = document.querySelectorAll('#contact-form .checkbox__input.marketing input');
          let marketing_checkboxes_selected = '';
          marketing_checkboxes.forEach(value => {
            if(value.checked === true) {
              marketing_checkboxes_selected += `${value.value}, `;
            }
          })

          fetch(url, {
            method: 'POST',
            body: JSON.stringify({
              'type': form_type,
              'name': forename + ' ' + surname,
              'forename': forename,
              'surname': surname,
              'company': company,
              'email': email,
              'telephone': telephone,
              'comments': comments,
              '_token': csrf_token,
              'g-recaptcha-response': recaptcha_token,
              'alternative-mailto': alternative_mailto,
              'crm_alt': crm_alt
            }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            document.body.classList.add('loaded');
            button.disabled = false;
            button.innerHTML = 'Submit Enquiry';
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' +
                response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status !== 'ok'){
              let errors = '';
              for (var i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              button.disabled = false;
              button.innerHTML = 'Submit Enquiry';
              return alert('There was a problem with your form\n\n'+errors);
            }

            button.disabled = false;
            button.innerHTML = 'Submit Enquiry';
            document.getElementsByClassName('contact-form')[0].reset();
            document.getElementsByClassName('contact-content')[0].classList.add('hidden');
            document.getElementsByClassName('contact-form-header')[0].classList.add('hidden');
            document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
            document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'General Enquiry Received'
            });


          }).catch(function(err) {
            document.body.classList.add('loaded');
            console.error('Fetch Error -', err);
            return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
          });

        });
      });

    });
  }
  // END Contact Form

   // Enquiry Form
  if(document.getElementById('send-enquiry-form')){
    // Do captcha and submit form

    let button_2 = document.querySelector('#send-enquiry-form');
    let terms_2 = document.querySelector('#contact-form [name=consent]');
    terms_2.onchange = function() {
      button_2.disabled = !this.checked;
    };

    document.getElementById('send-enquiry-form').addEventListener("click", function(e) {
      e.preventDefault();

      showLoader();
      button_2.disabled = true;
      button_2.innerHTML = 'Sending...';

      grecaptcha.ready(function() {
        grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
          document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

          let url = '/contact';
          let email = document.querySelector('#contact-form [name=email]').value;
          let name = document.querySelector('#contact-form [name=name]').value;
          // let surname = document.querySelector('#contact-form [name=surname]').value;
          let telephone = document.querySelector('#contact-form [name=telephone]').value;
          let comments = document.querySelector('#contact-form [name=comments]').value;
          let contact = document.querySelector('#contact-form [name=contact]').options[document.querySelector('#contact-form [name=contact]').selectedIndex].text;
          let time = document.querySelector('#contact-form [name=time]').options[document.querySelector('#contact-form [name=time]').selectedIndex].text;
          // let callback = '';
          // if (document.querySelector('#contact-form [name=date]') && document.querySelector('#contact-form [name=time]')){
          //   callback =`${document.querySelector('#contact-form [name=date]').value} ${document.querySelector('#contact-form [name=time]').value}`;
          // }
          let csrf_token = document.querySelector('#contact-form [name=_token]').value;

          let marketing_checkboxes = document.querySelectorAll('#contact-form .checkbox__input.marketing input');
          let marketing_checkboxes_selected = '';
          marketing_checkboxes.forEach(value => {
            if(value.checked === true) {
              marketing_checkboxes_selected += `${value.value}, `;
            }
          })

          if (document.querySelector('#contact-form [name=subscribe]').checked) {
            fetch('/newsletter', {
              method: 'POST', // or 'PUT'
              body: JSON.stringify({
                'name': name,
                'email': email,
                'mail_status': 'subscribed',
                '_token': csrf_token }),
              headers:{
                'Content-Type': 'application/json'
              }}).then(function(response) {
              if (response.status !== 200) {
                console.warn('Looks like there was a problem. Status Code: ' + response.status);
                return;
              }
              return response.json();
            }).then(function(data) {
              if(data.status !== 'ok'){
                let errors = '';
                for (let i in data.errors) {
                  errors += data.errors[i][0]+'\n';
                }
                return alert('There was a problem with your sign up details\n\n'+errors);
              }

              // Trigger event tracking
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': 'Newsletter Signup'
              });

            }).catch(function(err) {
              console.error('Fetch Error -', err);
            });
          }

          fetch(url, {
            method: 'POST',
            body: JSON.stringify({
              'name': name,
              // 'forename': forename,
              // 'surname': surname,
              'email': email,
              'telephone': telephone,
              'comments': `PREFERRED CONTACT METHOD: ${contact} \n\r PREFERRED CONTACT TIME: ${time} \n\r ADDITIONAL INFORMATION: ${comments}`,
              '_token': csrf_token,
              'g-recaptcha-response': recaptcha_token
            }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            document.body.classList.add('loaded');
            button_2.disabled = false;
            button_2.innerHTML = 'Submit Enquiry';
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' +
                response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status !== 'ok'){
              let errors = '';
              for (var i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              button_2.disabled = false;
              button_2.innerHTML = 'Submit Enquiry';
              return alert('There was a problem with your form\n\n'+errors);
            }

            button_2.disabled = false;
            button_2.innerHTML = 'Submit Enquiry';
            document.getElementsByClassName('contact-form')[0].reset();
            document.getElementsByClassName('contact-form-header')[0].classList.add('hidden');
            document.getElementsByClassName('contact-content')[0].classList.add('hidden');
            document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
            document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'General Enquiry Received'
            });


          }).catch(function(err) {
            document.body.classList.add('loaded');
            console.error('Fetch Error -', err);
            return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
          });

        });
      });

    });
  }
  // END Enquiry Form

  // FAQs Filters
  if (document.querySelector('#faq-tags-dropdown')){
    const faqCategory = (cat) => {
      if (cat === 'all') {
        document.querySelectorAll('.faq-tags > li').forEach(v => { v.classList.remove('active') })
        document.querySelector(`.faq-tags > li > a[data-category=all]`).parentElement.classList.add('active')
        document.querySelectorAll('#faq-list > div').forEach(v => { v.classList.remove('visuallyhidden') })
      } else {
        document.querySelectorAll('.faq-tags > li').forEach(v => { v.classList.remove('active') })
        document.querySelector(`.faq-tags > li > a[data-category=${cat}]`).parentElement.classList.add('active')
        document.querySelectorAll('#faq-list > div').forEach(v => { v.classList.add('visuallyhidden') })
        document.querySelectorAll(`#faq-list > div[data-category=${cat}]`).forEach(v => { v.classList.remove('visuallyhidden') })
      }
    }
    document.querySelectorAll('.faq-tags > li > a').forEach(v => {
      v.addEventListener('click', e => {
        faqCategory(e.target.dataset.category)
      })
    })
    document.querySelector('#faq-tags-dropdown').addEventListener('change', e => {
      faqCategory(e.target.options[e.target.selectedIndex].value)
    })
  }
  // END FAQs Filters

// FAQ Search
  const faqSearchBtn = document.querySelector('#faq-search-btn');
  if (faqSearchBtn) {
    let closeResultsBtn = document.querySelector('#close-results-btn');
    faqSearchBtn.addEventListener('click', function (e) {
      e.preventDefault();

      let search = document.querySelector('#faq-search');
      let all_data = document.querySelectorAll('#faq-list > div');
      let no_results = document.querySelector('#no-results');
      let result_list = document.querySelector('#search-results');

      if (search.value.trim() !== '') {
        result_list.innerHTML = '';
        no_results.classList.add('visuallyhidden');
        let i = 0;
        all_data.forEach((value) => {
          if (value.textContent.toLowerCase().includes(search.value.toLowerCase())) {
            i++;
            result_list.append(value.cloneNode(true));
          }
        });
        toggleAccordions();

        if (i < 1) {
          result_list.innerHTML = '';
          no_results.classList.remove('visuallyhidden');
        }
        document.querySelector('.search-results').classList.add('active');
      } else {
        document.querySelector('.search-results').classList.remove('active');
        result_list.innerHTML = '';
        no_results.classList.remove('visuallyhidden');
        toggleAccordions();
      }
    });

    if (closeResultsBtn) {
      closeResultsBtn.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector('.search-results').classList.remove('active');
      });
    }
  }
// END FAQs Search

// Subscribe Form - Popup
  let videoPopup = document.querySelector('#video-popup');
  if (videoPopup) {
    setTimeout(() => {
      document.body.classList.add('show-video')
    }, parseInt(videoPopup.dataset.delay));
    document.querySelector('#video-close').addEventListener('click', () => {
      const videoIframe = document.querySelector('#video-iframe iframe');
      videoIframe.removeAttribute('src');
      document.body.classList.remove('show-video');
      setTimeout(() => {
        videoPopup.classList.add('dismissed')
      }, 1000);
      writeCookie('video_dismissed', 'true', videoPopup.dataset.expiry)
    })


    if (document.querySelector('#video-trigger')) {
      // Video Section
      const videoButton = document.querySelector('#video-trigger');
      const videoWrapper = document.querySelector('#video-iframe');
      const imgWrapper = document.querySelector('.video-img');
      videoButton.addEventListener("click", function(e){
        e.preventDefault();
        let source = videoWrapper.querySelector('iframe').getAttribute('src');
        let height = imgWrapper.querySelector('img').clientHeight;
        videoWrapper.querySelector('iframe').setAttribute('src', `${source}?autoplay=1`);
        videoWrapper.style.paddingBottom = `${height}px`;
        imgWrapper.classList.add('visuallyhidden');
        videoWrapper.classList.add('active');
        videoPopup.classList.add('active');
      })
      // END Video Section

      // Video Modal
      const videoModal = new tingle.modal({
        footer: false,
        closeMethods: ['overlay', 'button', 'escape'],
        closeLabel: "Close",
        cssClass: ['video-modal'],
        onClose: function() {
          this.setContent('');
        }
      });
      // END Video Modal
    }
  }

  // Subscribe Form - Popup
  let newsletterPopup = document.querySelector('#newsletter-popup');
  if (newsletterPopup) {
    setTimeout(() => { document.body.classList.add('show-newsletter') }, parseInt(newsletterPopup.dataset.delay));
    document.querySelector('#newsletter-close').addEventListener('click', () => {
      document.body.classList.remove('show-newsletter');
      setTimeout(() => { newsletterPopup.classList.add('dismissed') }, 1000);
      writeCookie('newsletter_dismissed', 'true', newsletterPopup.dataset.expiry)
    })

    let button = document.querySelector('#email-signup-popup');
    let terms = document.querySelector('.newsletter-popup-inner-privacy [name=consent]');
    if(terms){
      terms.onchange = function() {
        button.disabled = !this.checked;
      };
    }

    document.getElementById('email-signup-popup').addEventListener("click", function(e) {
      e.preventDefault();
      let url = '/newsletter';
      let email = document.getElementById('newsletter-email-popup').value;
      let forename = document.getElementById('newsletter-name-popup').value;
      let token = document.getElementsByName('_token')[0].value;

      fetch(url, {
        method: 'POST', // or 'PUT'
        body: JSON.stringify({ 'name': forename, 'email': email, '_token': token }),
        headers:{
          'Content-Type': 'application/json'
        }}).then(function(response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        return response.json();
      }).then(function(data) {
        if(data.status!='ok'){
          let errors = '';
          for (var i in data.errors) {
            errors += data.errors[i][0]+'\n';
          }
          return alert('There was a problem with your sign up details\n\n'+errors);
        }

        newsletterPopup.querySelector('form').classList.add('visuallyhidden');
        newsletterPopup.querySelector('.newsletter-popup-inner-intro').classList.add('visuallyhidden');
        newsletterPopup.querySelector('.newsletter-popup-inner-privacy').classList.add('visuallyhidden');
        newsletterPopup.querySelector('.thank-you').classList.add('show');
        document.getElementsByClassName('newsletter-form-popup')[0].reset();
        setTimeout(() => { document.body.classList.remove('show-newsletter')  }, 1000);
        setTimeout(() => { newsletterPopup.classList.add('dismissed')  }, 2000);
        writeCookie('newsletter_dismissed', 'true', newsletterPopup.dataset.expiry);
        // Trigger event tracking
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Newsletter Form Submit'
        });

      }).catch(function(err) {
        console.error('Fetch Error -', err);
      });
    });
  }
  // END Subscribe Form - Popup

  // Subscribe Form
  if(document.getElementById('email-signup')){

    function checkConstraints() {
      let constraints = {
        name: {
          presence: {allowEmpty: false},
          length: {
            minimum: 3,
            message: "must be at least 3 characters"
          }
        },
        email_address: {
          presence: {allowEmpty: false},
          email: {
            message: function(value) {
              return validate.format("^<strong>%{em}</strong> is not a valid email", {
                em: value
              });
            }
          }
        }
      };
      let availableFields = [];
      document.querySelectorAll('.footer-newsletter-form [data-validate]').forEach((v)=>{
        (v.id === 'company' && v.required === false) ? null : availableFields.push(v.dataset.validate);
      })
      let availableConstraints = Object.fromEntries(availableFields.map(col => [col, constraints[col]]));

      document.querySelectorAll('.footer-newsletter-form [data-validate]').forEach((v)=>{
        if(v && v.value) { setTimeout(() => { v.dispatchEvent(new Event('keyup')) }, 500) }
        v.addEventListener('keyup', (e) => {
          let isValid = validate({
            name: (document.querySelector('#newsletter-name')) ? document.querySelector('#newsletter-name').value : null,
            email_address: (document.querySelector('#newsletter-email')) ? document.querySelector('#newsletter-email').value : null
          }, availableConstraints)

          let field = e.target.dataset.validate;
          if (isValid === undefined) {
            // document.querySelector('#send-enquiry').disabled = false;
            document.querySelectorAll(`.footer-newsletter-form [data-validate]`).forEach(v=>{v.classList.remove('invalid')});
            document.querySelector(`.footer-newsletter-form [data-validate=${field}]`).parentElement.classList.remove('form-group-error');
            document.querySelectorAll(`.footer-newsletter-form .validation-error`).forEach(v=>{v.remove()});
          } else {
            // document.querySelector('#send-enquiry').disabled = true;
            if (isValid[field] === undefined) {
              document.querySelector(`.footer-newsletter-form [data-validate=${field}]`).classList.remove('invalid');
              document.querySelector(`.footer-newsletter-form [data-validate=${field}]`).parentElement.classList.remove('form-group-error');
              document.querySelectorAll(`.footer-newsletter-form [data-validate=${field}] ~ .validation-error`).forEach(v=>{v.remove()});
            } else {
              document.querySelectorAll(`.footer-newsletter-form [data-validate=${field}] ~ .validation-error`).forEach(v=>{v.remove()});
              if(e.target.type !== 'checkbox') {
                document.querySelector(`.footer-newsletter-form [data-validate=${field}]`).classList.add('invalid');
                document.querySelector(`.footer-newsletter-form [data-validate=${field}]`).parentElement.classList.add('form-group-error');
                isValid[field].forEach(v => {
                  let error = document.createElement("p");
                  error.classList.add('validation-error');
                  error.innerHTML = `${v}`;
                  document.querySelector(`.footer-newsletter-form [data-validate=${field}]`).parentElement.appendChild(error);
                })
              }
            }
          }
        })
      })

    }
    checkConstraints();

    document.querySelector('#newsletter_consent').onchange = function() {
      this.checked ? document.querySelector('.footer-newsletter .v-error-consent').classList.add('hidden') : document.querySelector('.footer-newsletter .v-error-consent').classList.remove('hidden');
    };

    document.getElementById('email-signup').addEventListener("click", function(e) {
      e.preventDefault();

      if (!document.querySelector('#newsletter_consent').checked) {
        document.querySelector('.footer-newsletter .v-error-consent').classList.remove('hidden');
      } else {
        var recaptcha_token = null;

        if(document.querySelector('input[name=g-recaptcha-response]')){
          recaptcha_token = document.querySelector('input[name=g-recaptcha-response]').value;
        } else {
          grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(token) {
            recaptcha_token = token;
          });
        }

        // document.getElementById('email-signup').classList.add('preload');
        // document.getElementById('email-signup').innerText = 'please wait...';
        document.getElementById('email-signup').disabled = true;

        let url = '/newsletter';
        let email = document.getElementById('newsletter-email').value;
        let forename = document.getElementById('newsletter-name').value;
        let token = document.getElementsByName('_token')[0].value;

        fetch(url, {
          method: 'POST', // or 'PUT'
          body: JSON.stringify({ 'name': forename, 'email': email, 'mail_status': 'subscribed', '_token': token }), // data can be `string` or {object}!
          headers:{
            'Content-Type': 'application/json'
          }}).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          // document.getElementById('email-signup').classList.remove('preload');
          // document.getElementById('email-signup').innerText = 'sign up now.';
          document.getElementById('email-signup').disabled = false;

          if(data.status!='ok'){
            let errors = '';
            for (var i in data.errors) {
              errors += data.errors[i][0]+'\n';
            }
            if(typeof Swal !== 'undefined'){
              return Swal.fire({
                title: 'Whoops!',
                html: ('There was a problem with your sign up details\n\n'+errors).replace(/\n/gi,'<br>'),
                icon: 'error',
                confirmButtonText: 'OK',
              });
            } else {
              return alert('There was a problem with your sign up details\n\n'+errors);
            }
          }

          newsletterPopup ? writeCookie('newsletter_dismissed', 'true', newsletterPopup.dataset.expiry) : null;
          document.getElementsByClassName('footer-newsletter-form')[0].reset();
          // Trigger event tracking
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'Newsletter Signup'
          });

          if(typeof Swal !== 'undefined'){
            return Swal.fire({
              title: 'Thank you!',
              text: 'You\'re signed up!',
              icon: 'success',
              confirmButtonText: 'OK'
            });
          } else {
            return alert('Thank you!');
          }

        }).catch(function(err) {
          console.error('Fetch Error -', err);
          // document.getElementById('email-signup').classList.remove('preload');
          // document.getElementById('email-signup').innerHTML = 'sign up now.';
          document.getElementById('email-signup').disabled = false;
        });
      }

    });

  }

  // Uncheck compliance checkboxes
  let checkboxes = document.querySelectorAll('form [name=consent]');
  if(checkboxes.length > 0) {
    checkboxes.forEach(value => {
      value.checked = false;
    })
  }

  // Feefo Reviews
  const xhttp = new XMLHttpRequest();
  xhttp.onload = function() {
    let reviewsTop = document.querySelectorAll('.review-feefo');
    let response = JSON.parse(this.response);
    let reviewStrip = document.querySelectorAll('.review-strip');

    if(response && reviewsTop){
      let rating = response.rating.rating;
      let url = response.merchant.review_url;
      let calculatedValue = (rating / 5) * 100;

      reviewsTop.forEach(value => {
        if(value.querySelector('.reviews-rating > span:first-child')) {
          value.querySelector('.reviews-rating > span:first-child').innerHTML = rating;
        }
        value.querySelector('.star-rating-active').style.width = `${calculatedValue}%`;
        // value.querySelector('a').setAttribute('href', url)
        value.classList.remove('visuallyhidden');
      })
    } else {
      reviewsTop.forEach(value => {
        value ? value.classList.add('visuallyhidden') : null;
      })
    }

    if(response && reviewsTop && reviewStrip){
      let rating = response.rating.rating;
      let url = response.merchant.review_url;
      let calculatedValue = (rating / 5) * 100;
      let reviewsNumber = response.meta.verified_count;

      reviewStrip.forEach(value => {
        if(value.querySelector('.reviews-rating > span:first-child')) {
          value.querySelector('.reviews-rating > span:first-child').innerHTML = rating;
        }
        if(value.querySelector('.review-strip span.review-number')) {
          value.querySelector('.review-strip span.review-number').innerHTML = reviewsNumber;
        }
        value.querySelector('.star-rating-active').style.width = `${calculatedValue}%`;
        // value.querySelector('a').setAttribute('href', url)
        value.classList.remove('visuallyhidden');
      })
    } else {
      reviewStrip.forEach(value => {
        value ? value.classList.add('visuallyhidden') : null;
      })
    }

  }
  xhttp.open("GET", "https://api.feefo.com/api/20/reviews/summary/all?merchant_identifier=jurni&since_period=year");
  // xhttp.open("GET", "https://api.feefo.com/api/20/reviews/summary/all?merchant_identifier=bridle-vehicle-leasing");
  xhttp.send();

  // Feefo Reviews past year only
  // const xhttp1 = new XMLHttpRequest();
  // xhttp1.onload = function() {
  //   let reviewsTop = document.querySelectorAll('.review-feefo');
  //   let response = JSON.parse(this.response);
  //   let reviewStrip = document.querySelectorAll('.review-strip');
  //
  //   if(response && reviewsTop){
  //     let rating = response.rating.rating;
  //     let url = response.merchant.review_url;
  //     let calculatedValue = (rating / 5) * 100;
  //     console.log(response)
  //     console.log(rating)
  //     console.log(calculatedValue)
  //
  //     reviewsTop.forEach(value => {
  //       if(value.querySelector('.reviews-rating > span:first-child')) {
  //         value.querySelector('.reviews-rating > span:first-child').innerHTML = rating;
  //       }
  //       value.querySelector('.star-rating-active').style.width = `${calculatedValue}%`;
  //       value.querySelector('a').setAttribute('href', url)
  //       value.classList.remove('visuallyhidden');
  //     })
  //   } else {
  //     reviewsTop.forEach(value => {
  //       value ? value.classList.add('visuallyhidden') : null;
  //     })
  //   }
  //
  //   if(response && reviewsTop && reviewStrip){
  //     let rating = response.rating.rating;
  //     let url = response.merchant.review_url;
  //     let calculatedValue = (rating / 5) * 100;
  //     let reviewsNumber = response.meta.verified_count;
  //
  //     reviewStrip.forEach(value => {
  //       if(value.querySelector('.reviews-rating > span:first-child')) {
  //         value.querySelector('.reviews-rating > span:first-child').innerHTML = rating;
  //       }
  //       if(value.querySelector('.review-strip span.review-number')) {
  //         value.querySelector('.review-strip span.review-number').innerHTML = reviewsNumber;
  //       }
  //       value.querySelector('.star-rating-active').style.width = `${calculatedValue}%`;
  //       value.querySelector('a').setAttribute('href', url)
  //       value.classList.remove('visuallyhidden');
  //     })
  //   } else {
  //     reviewStrip.forEach(value => {
  //       value ? value.classList.add('visuallyhidden') : null;
  //     })
  //   }
  //
  // }
  // xhttp1.open("GET", "https://api.feefo.com/api/20/reviews/summary/all?merchant_identifier=jurni&since_period=year");
  // // xhttp1.open("GET", "https://api.feefo.com/api/20/reviews/summary/all?merchant_identifier=bridle-vehicle-leasing");
  // xhttp1.send();

  const xhttp2 = new XMLHttpRequest();
  xhttp2.onload = function() {
    let reviewsStrip = document.querySelector('.review-slider');
    let response = JSON.parse(this.response);

    if(response && reviewsStrip){
      let counter = 0;
      response.reviews.forEach(review => {
        if (counter >= 6) { return; }

        let reviewRating = review.service.rating ? review.service.rating.rating : '';
        let reviewTitle = review.service.title ? review.service.title : '';
        let reviewText = review.service.review ? review.service.review : '';
        let reviewName = review.customer ? (review.customer.display_name ? review.customer.display_name : '') : '';
        let reviewDate;
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        reviewDate = review.service ? (review.service.created_at ? new Date(review.service.created_at) : null) : null;

        if(reviewRating && reviewText && reviewName) {
          let review = `
              <div class="review-stars-wrapper">
                  <div class="review-stars star-rating review-stars--big"><div class="star-rating"><span class="star-rating-active" style="width:${reviewRating * 20}%"></span></div></div>
              </div>
              <p><strong class="bold ${reviewTitle ? null : 'visuallyhidden'}">${reviewTitle}</strong><span>${reviewText}</span></p>
              <div>
                  <div><p>${reviewName} ${reviewDate ? '- ' + getOrdinalNum(reviewDate.getDate()) + '&nbsp;' + months[reviewDate.getMonth()] + '&nbsp;' + reviewDate.getFullYear() : null}</p></div>
              </div>`;
          let reviewNode = document.createElement('div');
          reviewNode.classList.add('review-slider-grid-item');
          reviewNode.innerHTML = review;
          reviewsStrip.querySelector('.review-slider-grid').prepend(reviewNode);

          counter++;
        }
      })

      // Review Slider
      const reviewSlider = document.querySelector('.review-slider .review-slider-grid');
      if (reviewSlider) {
        const glider = new Glider(reviewSlider, {
          slidesToScroll: 1,
          slidesToShow: 1,
          draggable: true,
          scrollLock: true,
          arrows: {
            prev: '.review-slider .glider-prev',
            next: '.review-slider .glider-next'
          },
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 1281,
              settings: {
                slidesToShow: 3
              }
            }
          ]
        })
        sliderAuto(glider, 10000);
      }
      // END Review Slider
    } else {
      if(reviewsStrip){
        reviewsStrip.classList.add('visuallyhidden');
      }
    }

  }
  xhttp2.open("GET", "https://api.feefo.com/api/20/reviews/all?merchant_identifier=jurni&since_period=year");
  // xhttp2.open("GET", "https://api.feefo.com/api/20/reviews/all?merchant_identifier=low-cost-vans");
  xhttp2.send();

  // Derivative Video
  let dealReview = document.querySelector('#review-video');
  let dealReviewVideo = document.querySelector('#review-video .embed-responsive');
  if (dealReview && dealReviewVideo){
    dealReviewVideo.addEventListener('click', () => {
      document.querySelector('#review-video .video-icon').classList.add('visuallyhidden');
    })
  }

  // Top Bar Active Class Hover
  const navItems = document.querySelectorAll('.top-bar-nav-item');
  const navItemActive = document.querySelector('.top-bar-nav-item.active');
  navItems.forEach(item => {
    item.addEventListener('mouseover', () => {
      navItemActive.classList.remove('active');
    });
    item.addEventListener('mouseout', () => {
      navItemActive.classList.add('active');
    });
  });

  // Sort Manufacturer Boxes
  const dropdown = document.getElementById("sort-by");
  const rangeList = document.getElementById("range_list");

  if(dropdown && rangeList) {
    function sortRangeBoxes(order) {
      let rangeBoxes = Array.from(document.querySelectorAll(".range-box"));

      rangeBoxes.sort(function(a, b) {
        let aPrice = parseFloat(a.getAttribute("data-price"));
        let bPrice = parseFloat(b.getAttribute("data-price"));

        return order === "asc" ? aPrice - bPrice : bPrice - aPrice;
      });

      rangeList.innerHTML = "";

      rangeBoxes.forEach(function(box) {
        rangeList.appendChild(box);
      });
    }

    //Default sort ascending
    sortRangeBoxes("asc");

    dropdown.addEventListener("change", function() {
      let selectedOption = dropdown.value;

      if (selectedOption === "Sort By: Price (Low-High)") {
        sortRangeBoxes("asc");
      } else if (selectedOption === "Sort By: Price (High-Low)") {
        sortRangeBoxes("desc");
      }
    });
  }
  // END Sort Manufacturer Boxes

  // Derivative Review Show More
  let reviewMoreElements = document.querySelectorAll('.review-content');
  let toggleLinkElements = document.querySelectorAll('.review-content .show-all > a');

  reviewMoreElements.forEach((reviewMore, index) => {
      let toggleLink = toggleLinkElements[index];

      if (reviewMore && toggleLink) {
          toggleLink.addEventListener('click', (e) => {
              reviewMore.classList.toggle('active');
              reviewMore.classList.contains('active') ? toggleLink.querySelector('span').innerHTML = 'Show Less' : toggleLink.querySelector('span').innerHTML = 'Read Full Review';
          });
      }
  });

  // Search Derivative Specification
  // function setupSpecificationSearch(identifier) {
  //   let search = document.querySelector(`#specification-search-${identifier}`);
  //   let all_data = document.querySelectorAll(`#technical-data-${identifier} li, #key-info-${identifier} li`);
  //   let no_results = document.querySelector(`#specification-search-results-${identifier} .no-results`);
  //   let result_list = document.querySelector(`#specification-search-results-${identifier} ul`);
  //
  //   search.addEventListener('focus', function (e) {
  //     document.querySelectorAll('.tab-content, .tab').forEach(value => { value.classList.remove('active') });
  //     document.querySelector(`#specification-search-results-${identifier}`).classList.add('active');
  //   });
  //
  //   search.addEventListener('input', function (e) {
  //     if (e.target.value !== '') {
  //       result_list.innerHTML = '';
  //       no_results.classList.add('visuallyhidden');
  //       let i = 0;
  //       all_data.forEach((value) => {
  //         if (value.textContent.toLowerCase().includes(search.value.toLowerCase())) {
  //           i++;
  //           result_list.append(value.cloneNode(true));
  //         }
  //       })
  //       if (i < 1) {
  //         result_list.innerHTML = '';
  //         no_results.classList.remove('visuallyhidden');
  //       }
  //     } else {
  //       result_list.innerHTML = '';
  //       no_results.classList.remove('visuallyhidden');
  //     }
  //   });
  // }
  //
  // setupSpecificationSearch('1');
  // setupSpecificationSearch('2');

  //Partner Page - Show pinpoint labels
  const mapMarkers = document.querySelectorAll('.map-marker');

  if(mapMarkers.length > 0){
    mapMarkers.forEach(marker => {
      marker.addEventListener('click', function () {
        mapMarkers.forEach(m => {
          if (m !== marker) {
            m.classList.remove('show-info');
          }
        });
        this.classList.toggle('show-info');
      });
    });
  }

});

setTimeout(function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
}, 2000);
document.addEventListener("DOMContentLoaded", function() {
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});
document.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});
window.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader

  // // Load Sidebar Search
  // if (document.getElementsByClassName('search-aside').length > 0) {
  //   updateSearchToggles();
  //   loadSearchTriggers();
  // }

  // Load Search Form
  function loadSearchForm () {
    // Load Search Form
    if(document.getElementsByClassName('search-form').length>0){
      loadBudgetSlider();
      updateSearchToggles();
      loadSearchTriggers();
      // Search
      var searchType = document.querySelector('#search-type') ? document.querySelector('#search-type').value : 'car';
      if (document.querySelector('#search-bar')) {
        loadManufacturers(searchType);
        loadBodyTypes(searchType);
      } else {
        // loadManufacturersRadio(searchType);
        loadBodyTypesRadio(searchType);
      }
      document.querySelectorAll('.search-form [name=search-type]').forEach(v => { v.addEventListener("change", function(e){
        if (document.querySelector('#search-bar')) {
          loadManufacturers(searchType, e.target.value);
        } else {
          loadManufacturersRadio(searchType, e.target.value);
          loadBodyTypesRadio(searchType, e.target.value);
        }
      })
      });

      document.querySelectorAll('.search-form [name=make]').forEach(v => { v.addEventListener("change", function(e){
        if (document.querySelector('#search-bar')) {
          if (document.querySelector('[name="fuel_type"]')) {
            loadModels(searchType, e.target.value, true);
          } else {
            loadModels(searchType, e.target.value);
          }
        } else {
          loadModelsRadio(searchType, e.target.value);
          console.log(e.target.value)
          console.log(searchType)
        }
      })
      });
    }
  }
  loadSearchForm();
  // END Load Search Form

  // Search Sidebar Toggle
  let sidebarToggle = document.querySelector('#search-filters-toggle');
  if (sidebarToggle) {
    sidebarToggle.addEventListener('click', (e) => {
      if (!sidebarToggle.parentElement.classList.contains('active')) {
        setTimeout(() => {
          document.querySelector('body').scrollIntoView();
          console.log(document.querySelector('#search-filters-toggle').parentElement.parentElement)
        }, 500);
        // document.querySelector('.search-content').style.minHeight = `${(document.querySelector('.search-results-form').clientHeight) * 2}px`;
      } else {
        e.preventDefault();
        // document.querySelector('.search-content').style.minHeight = `100px`;
      }
      sidebarToggle.parentElement.classList.toggle('active');
      sidebarToggle.blur();
      sidebarToggle.parentElement.focus();
    })
  }
  // END Search Sidebar Toggle

  // Search Mobile Popup
  const filterButton = document.querySelector('.search-filters-mobile .vehicle-filters');
  const termsButton = document.querySelector('.search-filters-mobile .vehicle-terms');
  let searchSidebar = document.querySelector('.search-aside');
  let searchTerms = document.querySelector('.search-filters');
  // const updateMobileResultsBtn = document.querySelector('.update-mobile-results');
  let modelSelected = 0;
  let specSelected = 0;

  if(filterButton && searchSidebar){
    const modalMobileFilters = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: ['mobile-sidebar'],
      beforeOpen: function () {
        // modelSelected = document.querySelector('.search-aside select[name="model"]').selectedIndex
        // specSelected = document.querySelector('.search-aside select[name="spec_level"]').selectedIndex
        searchSidebar ? modalMobileFilters.setContent(searchSidebar.outerHTML) : null;
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
      },
      onOpen: function () {
        let searchAside = document.querySelector('.search-content .search-aside');
        searchAside.remove();
        // let headerHeight = updateMobileResultsBtn.offsetHeight;
        // document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
        // loadSearchTriggers();
        // updateSearchToggles();
        loadSearchForm();
        // loadUrlParams();
        // resetSearch()
        // document.querySelector('.search-aside select[name="model"]').selectedIndex = modelSelected;
        // document.querySelector('.search-aside select[name="spec_level"]').selectedIndex = specSelected;
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 1000);
      },
      onClose: function() {
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
        filterButton.parentElement.classList.remove('is-active');
        let searchTingle = document.querySelector('.tingle-modal-box__content .search-aside');
        document.querySelector('.search-content').prepend(searchTingle);
        // loadSearchTriggers();
        // updateSearchToggles();
        loadSearchForm();
        // loadUrlParams();
        // resetSearch()
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 500);
      }
    });

    filterButton.addEventListener("click", function(e){
      filterButton.parentElement.classList.toggle('is-active');
      if(filterButton.parentElement.classList.contains("is-active")) {
        modalMobileFilters.open();
      } else{
        modalMobileFilters.close();
      }
    })
  }
  if(termsButton && searchTerms){
    const modalMobileTerms = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: ['mobile-sidebar-terms'],
      beforeOpen: function () {
        // modelSelected = document.querySelector('.search-aside select[name="model"]').selectedIndex
        // specSelected = document.querySelector('.search-aside select[name="spec_level"]').selectedIndex
        searchTerms ? modalMobileTerms.setContent(searchTerms.outerHTML) : null;
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
      },
      onOpen: function () {
        searchTerms = document.querySelector('.search-filters');
        searchTerms.remove();
        // let headerHeight = updateMobileResultsBtn.offsetHeight;
        // document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
        // loadSearchTriggers();
        // updateSearchToggles();
        // priceToggles();
        // toggleSwitches();
        // togglePrices();
        // updatePrice();
        loadSearchForm();
        searchSorter();
        // loadUrlParams();
        // document.querySelector('.search-aside select[name="model"]').selectedIndex = modelSelected;
        // document.querySelector('.search-aside select[name="spec_level"]').selectedIndex = specSelected;
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 1000);
        // resetSearch()
      },
      onClose: function() {
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
        termsButton.parentElement.classList.remove('is-active');
        let searchTingle = document.querySelector('.tingle-modal-box__content .search-filters');
        document.querySelector('.deal-list.deal-boxes').insertAdjacentElement('beforebegin', searchTingle);
        // loadSearchTriggers();
        // updateSearchToggles();
        // priceToggles();
        // toggleSwitches();
        // togglePrices();
        // updatePrice();
        loadSearchForm();
        searchSorter();
        // loadUrlParams();
        // updateMobileResults();
        // resetSearch()
        setTimeout(() => { toggleAccordions(); }, 500);
      }
    });

    termsButton.addEventListener("click", function(e){
      termsButton.parentElement.classList.toggle('is-active');
      if(termsButton.parentElement.classList.contains("is-active")) {
        modalMobileTerms.open();
      } else{
        modalMobileTerms.close();
      }
    })
  }
  // END Search Mobile Popup

  // Range/Model Filters Mobile Popup
  const rangeFilterButton = document.querySelector('.range-filters-mobile .vehicle-filters');
  const rangeTermsButton = document.querySelector('.range-filters-mobile .vehicle-terms');
  const rangeSidebar = document.querySelector('#filter-terms .search-wrapper');
  // const updateMobileResultsBtn = document.querySelector('.update-mobile-results');
  if(rangeFilterButton && rangeSidebar){
    const modalMobileFilters = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: ['mobile-sidebar'],
      beforeOpen: function () {
        rangeSidebar ? modalMobileFilters.setContent(rangeSidebar.outerHTML) : null;
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
      },
      onOpen: function () {
        let searchAside = document.querySelector('#filter-terms .search-wrapper');
        searchAside.remove();
        // let headerHeight = updateMobileResultsBtn.offsetHeight;
        // document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
        // loadSearchTriggers();
        // updateSearchToggles();
        // loadSearchForm();
        // resetSearch()
        rangeTable()
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 1000);
      },
      onClose: function() {
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
        rangeFilterButton.parentElement.classList.remove('is-active');
        let searchTingle = document.querySelector('.tingle-modal-box__content  .search-wrapper');
        document.querySelector('#filter-terms').prepend(searchTingle);
        // loadSearchTriggers();
        // updateSearchToggles();
        // loadSearchForm();
        // resetSearch()
        rangeTable()
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 500);
      }
    });

    rangeFilterButton.addEventListener("click", function(e){
      rangeFilterButton.parentElement.classList.toggle('is-active');
      if(rangeFilterButton.parentElement.classList.contains("is-active")) {
        modalMobileFilters.open();
      } else{
        modalMobileFilters.close();
      }
    })
  }
  if(rangeTermsButton && rangeSidebar){
    const modalMobileTerms = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: ['mobile-sidebar-terms'],
      beforeOpen: function () {
        // modelSelected = document.querySelector('.search-aside select[name="model"]').selectedIndex
        // specSelected = document.querySelector('.search-aside select[name="spec_level"]').selectedIndex
        rangeSidebar ? modalMobileTerms.setContent(rangeSidebar.outerHTML) : null;
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
      },
      onOpen: function () {
        let searchAside = document.querySelector('#model-table-header');
        searchAside.remove();
        // let headerHeight = updateMobileResultsBtn.offsetHeight;
        // document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
        // loadSearchTriggers();
        // updateSearchToggles();
        // loadSearchForm();
        rangeTable()
        // document.querySelector('.search-aside select[name="model"]').selectedIndex = modelSelected;
        // document.querySelector('.search-aside select[name="spec_level"]').selectedIndex = specSelected;
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 1000);
        // resetSearch()
      },
      onClose: function() {
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
        rangeTermsButton.parentElement.classList.remove('is-active');
        let searchTingle = document.querySelector('.tingle-modal-box__content #model-table-header');
        document.querySelector('.model-table').prepend(searchTingle);
        // loadSearchTriggers();
        // updateSearchToggles();
        // loadSearchForm();
        rangeTable()
        // updateMobileResults();
        // resetSearch()
        setTimeout(() => { toggleAccordions(); }, 500);
      }
    });

    rangeTermsButton.addEventListener("click", function(e){
      rangeTermsButton.parentElement.classList.toggle('is-active');
      if(rangeTermsButton.parentElement.classList.contains("is-active")) {
        modalMobileTerms.open();
      } else{
        modalMobileTerms.close();
      }
    })
  }
  // END Range/Model Filters Mobile Popup

  // Show Only Filters
  // let searchToggles = document.querySelectorAll('.search-results .search-filters input');
  // if (searchToggles) {
  //   searchToggles.forEach(value => {
  //     value.addEventListener('change', (e) => {
  //       let searchUrl = new URL(window.location.origin + '/car-leasing');
  //       let vans = (window.location.pathname.includes('van-leasing') || window.location.search.includes('search-type=van')) ? '/van-leasing' : '';
  //       (window.location.pathname.includes('van-leasing')) ? searchUrl = new URL(window.location.origin + '/van-leasing') : null;
  //       (e.target.value === 'special' && e.target.checked) ? searchUrl = new URL(window.location.origin + vans + '/special-offers') : null;
  //       (e.target.value === 'stock' && e.target.checked) ? searchUrl = new URL(window.location.origin + vans + '/stock') : null;
  //       showLoader();
  //       window.location.href = searchUrl;
  //     })
  //   })
  // }
  // END Show Only Filters

});